export const QUESTIONS = [
    {
       "id":1,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following is the most scalable physical architecture for East-West traffic patterns?",
       "choice_a":"Two-tier collapsed core",
       "choice_b":"Leaf-and-spine architecture",
       "choice_c":"Routed",
       "choice_d":"Three-tier",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Leaf-and-spine architecture is the most scalable choice for networks with predominately East-West traffic patterns such as data center networks. Routed is not a physical architecture, but rather a layer 2 architecture."
    },
    {
       "id":2,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Analyze design principles of a WLAN deployment",
       "question":"A client performs an intra-controller roam, keeping its IP address. Which of the following is true of this roam?",
       "choice_a":"The SSID changes.",
       "choice_b":"The VLAN changes.",
       "choice_c":"It's a layer 2 roam.",
       "choice_d":"It's a layer 3 roam.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"In an intracontroller roam, the client associates with a different AP that's connected to the same WLAN controller. Neither the VLAN nor the Service Set Identifier (SSID) changes. Because the client's IP address didn't change, you can conclude this is a layer 2 roam."
    },
    {
       "id":3,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which QoS Class Selector is the lowest priority?",
       "choice_a":"CS0",
       "choice_b":"CS1",
       "choice_c":"CS7",
       "choice_d":"EF",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"CS1 get a lower priority than CS0. CS0 is the default class and is for best-effort traffic. CS1 is the bottom-of-the-barrel traffic that you may not even want on your network, such as torrents, gaming, or cat videos."
    },
    {
       "id":4,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which of the following prevent TCP global synchronization? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Explicit congestion notification</li><li> Policing</li><li> Weighted random early detection</li><li> Fair queuing</li></ol>",
       "choice_a":"A, B",
       "choice_b":"A, C",
       "choice_c":"A, D",
       "choice_d":"B, C",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"TCP global synchronization occurs when multiple TCP flows back off, then ramp up simultaneously. This can happen when a queue fills and excess packets are tail-dropped. Weighted random early detection (WRED) randomly drops packets as the queue fills. Explicit congestion notification (ECN) works by getting a TCP sender to slow down the rate at which it sends by reducing its congestion window."
    },
    {
       "id":5,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which of the following queues can never exceed its bandwidth allocation during times of congestion?",
       "choice_a":"Low-latency queue",
       "choice_b":"Class-based weighted fair queue",
       "choice_c":"Policing queue",
       "choice_d":"Priority queue",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The low-latency queuing (LLQ) is serviced before any other queues, so packets in the LLQ won't wait any longer than necessary. The LLQ has a limited bandwidth."
    },
    {
       "id":6,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-Access solution",
       "question":"What type of encapsulation does SD-Access use?",
       "choice_a":"LISP",
       "choice_b":"IPsec",
       "choice_c":"VXLAN",
       "choice_d":"GRE",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"SD-Access uses VXLAN encapsulation because it can carry Ethernet frames. The others can't."
    },
    {
       "id":7,
       "topic_id":1,
       "practice_test_id":1,
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Which of the following is <italic>not</italic> a component of SD-WAN?",
       "choice_a":"DTLS",
       "choice_b":"BGP",
       "choice_c":"OMP",
       "choice_d":"IPsec",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Software-defined networking in a wide area network (SD-WAN) doesn't use BGP."
    },
    {
       "id":8,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following protocols operate at the Physical layer?",
       "choice_a":"HDLC",
       "choice_b":"IEEE 802.3",
       "choice_c":"PPP",
       "choice_d":"Twisted pair",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"IEEE 802.3 Ethernet operates at both the Physical and Data Link layers. PPP and HDLC are Data Link layer protocols. Twisted pair is a type of cable; physical media isn't part of the Physical layer."
    },
    {
       "id":9,
       "topic_id":1,
       "practice_test_id":4,
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"What layer does ARP operate at?",
       "choice_a":2,
       "choice_b":3,
       "choice_c":4,
       "choice_d":7,
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"You'll hear disagreement as to whether ARP is a layer 2 or layer 3 protocol. Some even going so far as to call it a layer 2.5 protocol! ARP packets fit the definition of what the OSI model calls protocol control information. In addition to just providing a mapping between MAC and IP addresses, the fact that a node sends ARP packets indicates its willingness to use IP. In that respect, ARP is decidedly a layer 2 protocol."
    },
    {
       "id":10,
       "topic_id":1,
       "practice_test_id":5,
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"What are two examples a single collision domain? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> A single fiber strand that carries separate light frequencies for sending and receiving</li><li> Wireless</li><li> Two fiber strands, one for sending and another for receiving</li><li> A twisted-pair cable with a single pair of wires for sending and receiving</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"B, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Wireless and a single pair of wires for sending and receiving each represent a single collision domain. The other two allow for full-duplex communication."
    },
    {
       "id":11,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"What can be done to achieve full-duplex communication?",
       "choice_a":"Use fiber-optic cables",
       "choice_b":"Use TCP",
       "choice_c":"Use different pairs of wires for transmitting and receiving",
       "choice_d":"Set the interface speeds to something greater than 10 Mbps",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"You can achieve full-duplex communication by separating the transmitting and receiving functions. This can be done by using either separate media or separate frequencies. There's no need to use fiber-optic cables, TCP, or a speed greater than 10 Mbps."
    },
    {
       "id":12,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Differentiate hardware and software switching mechanisms",
       "question":"What's the default global aging time for the MAC address table?",
       "choice_a":"30 seconds",
       "choice_b":"5 minutes",
       "choice_c":"1 hour",
       "choice_d":"4 hours",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The default aging timeout is 300 seconds (5 minutes). It can be disabled or set as high as 1,000,000 seconds, although neither of those extremes are recommended, because the size of the MAC address table is limited based on the amount of memory available in the CAM table."
    },
    {
       "id":13,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Differentiate hardware and software switching mechanisms",
       "question":"What occurs when the MAC address table is full?",
       "choice_a":"All entries in the table are deleted.",
       "choice_b":"The oldest entries are aged out.",
       "choice_c":"Frames addressed to a MAC address that's not in the table are flooded.",
       "choice_d":"Frames addressed to a MAC address that's not in the table are dropped.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Once the MAC address table is full, the switch will flood traffic to every destination MAC not in the table. The oldest entries are not necessarily aged out, since the aging time is based on when the switch last saw traffic from the MAC address. It's not based on when the entry was created."
    },
    {
       "id":14,
       "topic_id":1,
       "practice_test_id":4,
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following is a function of a bridge?",
       "choice_a":"MAC-based routing",
       "choice_b":"IP-based routing",
       "choice_c":"Connecting two VLANs together",
       "choice_d":"Reducing the size of a broadcast domain",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Bridges-usually called switches-perform a crude form of routing using the MAC address table. This reduces the need for flooding but doesn't reduce the size of the broadcast domain. Bridges don't perform IP-based routing and don't connect VLANs together."
    },
    {
       "id":15,
       "topic_id":1,
       "practice_test_id":5,
       "domain":"Architecture",
       "sub_domain":"Differentiate hardware and software switching mechanisms",
       "question":"What information does the MAC address table store? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> IP address</li><li> VLAN</li><li> ARP entries</li><li> Interface</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The MAC address table stores a source MAC address and the VLAN and interface where it was last seen. The MAC address table doesn't store IP addresses or ARP entries."
    },
    {
       "id":16,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following best describes traffic between a database server and a web server?",
       "choice_a":"North-South",
       "choice_b":"East-West",
       "choice_c":"Client-server",
       "choice_d":"Intra-VLAN",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"East-West traffic typically describes server-to-server traffic."
    },
    {
       "id":17,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following best describes traffic between an IP phone and a DNS server?",
       "choice_a":"North-South",
       "choice_b":"East-West",
       "choice_c":"Point-to-point",
       "choice_d":"Inter-VLAN",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"North-South traffic generally describes client-server traffic flows."
    },
    {
       "id":18,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following is the most scalable physical architecture for North-South traffic patterns?",
       "choice_a":"Leaf-and-spine architecture",
       "choice_b":"Two-tier collapsed core",
       "choice_c":"Three-tier",
       "choice_d":"Routed",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The three-tier architecture is the most scalable because it's modular, but this also makes it costly. The three-tier collapsed core combines the Access and Distribution/Aggregation layers into one layer, allowing you to get by with fewer switches. Leaf-and-spine architecture is a good choice for networks with predominately East-West traffic patterns such as data center networks. Routed is not a physical architecture, but rather a layer 2 architecture."
    },
    {
       "id":19,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following layers should always be routed?",
       "choice_a":"Access",
       "choice_b":"Aggregation",
       "choice_c":"Distribution",
       "choice_d":"Core",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Configuration in the Core layer should be as simple as possible, so all connections within the core should be always be routed. Routing may be a good choice for the Access and Distribution/Aggregation layers, but there are times when it may be more convenient to use switching in these layers."
    },
    {
       "id":20,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following should be in the same distribution block?<ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Web application load balancer</li><li> An IP phone</li><li> A web server</li><li> An Internet router</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Hosts that have a similar function should be placed in the same distribution block. This provides isolation and scalability. For example, a web server and a web application load balancer would belong in the same distribution block. An IP phone would likely be in a separate block along with other campus devices such as printers and workstations. An Internet router may be in a block along with other WAN edge devices such as firewalls."
    },
    {
       "id":21,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following is true regarding a routed interface on a switch?",
       "choice_a":"It must be assigned an IP address.",
       "choice_b":"It consumes one VLAN.",
       "choice_c":"It can be configured as a trunk port.",
       "choice_d":"It can be assigned two IP addresses.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"A routed interface can have a primary and a secondary IP address. You can't assign an IP address directly to a switched interface. However, you can assign a primary and a secondary IP address to an SVI."
    },
    {
       "id":22,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following layer 2 topologies let you span a VLAN across more than two switches? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Looped</li><li> Loop-free U</li><li> Loop-free inverted-U</li><li> Routed</li></ol>",
       "choice_a":"A, B",
       "choice_b":"A, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Looped, loop-free invert-U, and VSS topologies allow you to span a VLAN across more than two access switches."
    },
    {
       "id":23,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following is true of using a VSS topology?",
       "choice_a":"You should disable Spanning Tree when using VSS.",
       "choice_b":"There's no need to run a FHRP.",
       "choice_c":"Access switches must connect to the virtual switch using multichassis EtherChannels.",
       "choice_d":"The active and standby both perform IP routing to avoid asymmetric routing.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Stateful switchover (SSO) with non-stop forwarding (NSF) lets you configure the virtual switch IP as a default gateway for hosts. If one switch fails, the other will take over. There's no need to use a first-hop redundancy protocol. You should still run Spanning Tree with VSS to block any accidental redundant links that fall outside of an EtherChannel. Only the active switch does IP routing."
    },
    {
       "id":24,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Given two distribution switches and one VLAN that spans four access switches, which layer 2 topology will consume the fewest number of ports on the distribution switches?",
       "choice_a":"Looped triangle",
       "choice_b":"Looped square",
       "choice_c":"Routed",
       "choice_d":"Loop-free U",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The looped square will consume fewer ports on the distribution switches. A loop-free U topology can support VLANs that span up to two access switches. The routed topology supports only one access switch per VLAN."
    },
    {
       "id":25,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"What are two differences between the VSS topology and the looped triangle? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> The looped triangle can't use EtherChannels.</li><li> The looped triangle has blocked links.</li><li> The VSS requires access switches to be directly connected to one another.</li><li> The VSS has no links blocking.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"B, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The underlying physical topology of VSS can have loops, but the VSS is logically loop-free because the member switches behave as a single switch and the access switches use multichassis EtherChannel. VSS thus doesn't require Spanning Tree to block any links. The looped triangle depends on Spanning Tree to prevent bridging loops. Any topology can use EtherChannels."
    },
    {
       "id":26,
       "topic_id":1,
       "practice_test_id":4,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"How many classes does the Class Selector PHB group include?",
       "choice_a":6,
       "choice_b":7,
       "choice_c":8,
       "choice_d":9,
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"There are nine possible values: CS0 through CS7, and LE."
    },
    {
       "id":27,
       "topic_id":1,
       "practice_test_id":5,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which Class Selector value has the highest priority?",
       "choice_a":"LE",
       "choice_b":"CS0",
       "choice_c":"CS1",
       "choice_d":"CS2",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"LE and CS1 are for \u0022lower effort\u0022 traffic and are sometimes referred to as scavenger classes. CS0 is the default class and is for best-effort traffic. CS2 has the highest DSCP value and thus the highest priority."
    },
    {
       "id":28,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which of the following DSCP PHB groups lets you choose a drop precedence?",
       "choice_a":"CS",
       "choice_b":"AF",
       "choice_c":"EF",
       "choice_d":"CoS",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Only the assured forwarding (AF) PHB values includes drop precedence. CoS is an Ethernet field used for QoS, but it's not part of the DiffServ Code Points (DSCP) specification."
    },
    {
       "id":29,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Assured forwarding (AF) code points take the format AF<italic>xy</italic>. What do <italic>x</italic> and <italic>y</italic> indicate? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> <italic>x</italic>is drop priority</li><li> <italic>x</italic>is priority</li><li> <italic>y</italic>is drop precedence</li><li> <italic>y</italic>is priority",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"<italic>x</italic>is the priority; <italic>y</italic>is the drop precedence or drop priority."
    },
    {
       "id":30,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which of the following DSCP values is best for TCP-based video teleconferencing traffic?",
       "choice_a":"CS1",
       "choice_b":"EF",
       "choice_c":"CS0",
       "choice_d":"AF41",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"What constitutes the best DSCP value for an application can be subjective. A video teleconferencing application will have tight delay requirements, so CS0 and CS1 are not candidates because they're for best-effort and lower-effort traffic, respectively. EF is designed for voice and is usually bandwidth constrained. AF41 offers a reasonably high priority, and the assured forwarding group is meant for applications that can tolerance some packet loss."
    },
    {
       "id":31,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"A router receives an IP packet encapsulated in an Ethernet frame tagged with a priority code point value of 0. The router isn't configured with any QoS tools. What will happen when the router forwards the IP packet to its next hop over Ethernet?",
       "choice_a":"Convert the priority code point to DSCP",
       "choice_b":"Encapsulate the IP packet inside an Ethernet frame with no CoS marking",
       "choice_c":"Preserve the PCP value when forwarding the frame",
       "choice_d":"Drop the frame",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"When a router routes an IP packet, it decapsulates the packet and discards the frame. It encapsulates the packet in a new frame before forwarding. CoS values are included in 802.1Q frames, and the router isn't configured to do any marking. Hence, the new frame will have no CoS marking."
    },
    {
       "id":32,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"What is true of traffic policing? <liA> It can be applied to inbound traffic.</li><li> It is always applied to all traffic.</li><li> It can be applied to outbound traffic.</li><li> Packets that are exceeding are always discarded.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Policing can be applied to inbound or outbound traffic. You can choose the traffic you want to police and what action to take for traffic that exceeds the CIR."
    },
    {
       "id":33,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"In single-rate, two-color policing, given a CIR of 150 kbps, how many tokens can the token bucket hold?",
       "choice_a":150,
       "choice_b":1500,
       "choice_c":15000,
       "choice_d":150000,
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The bucket size is one token for every bit of the CIR. A CIR of 150,000 bps would create a bucket that can hold 150,000 tokens."
    },
    {
       "id":34,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"In three-color policing, what does red mean?",
       "choice_a":"Packets are violating and will be marked down",
       "choice_b":"Packets are violating and will be dropped",
       "choice_c":"Packets are exceeding and will be marked down",
       "choice_d":"Packets are exceeding and will be dropped",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Red means packets are violating-exceeding the number of tokens in both the bc and be buckets-and will be dropped."
    },
    {
       "id":35,
       "topic_id":1,
       "practice_test_id":4,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"In three-color policing, what does yellow mean?",
       "choice_a":"Packets are violating and will be marked down",
       "choice_b":"Packets are violating and will be dropped",
       "choice_c":"Packets are exceeding and will be marked down",
       "choice_d":"Packets are exceeding and will be dropped",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Yellow means packets are exceeding only the amount of tokens in the bc bucket but not the number of tokens in the bc and be buckets combined. Yellow packets are forwarded after being marked down."
    },
    {
       "id":36,
       "topic_id":1,
       "practice_test_id":5,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"On a router you configure a single-rate, three-color egress policer with a CIR of 1 Mbps, a committed burst size of 64,000 bytes, and an excess burst of 32,000 bytes. In one second, a packet 262,500 bytes in size comes in and must be forwarded. What will the router do with this packet?",
       "choice_a":"Immediately forward it untouched",
       "choice_b":"Drop it",
       "choice_c":"Forward it and mark it down",
       "choice_d":"Queue it",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The policer can burst up to about 1.77 Mbps, but the packet is 2,100,000 bits in size. The router will therefore drop it."
    },
    {
       "id":37,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"A single-rate, three-color egress policer receives a packet. The policer's bc and be buckets are full. To forward the packet would require using all tokens in the bc bucket, without needing to dip into the be bucket. What will happen to the packet?",
       "choice_a":"It will be dropped.",
       "choice_b":"It will be marked down and forwarded.",
       "choice_c":"It will be forwarded as is.",
       "choice_d":"It will be queued.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"If a packet can be forwarded using only the tokens in the bc bucket, it's said to be conforming and will be forwarded as is."
    },
    {
       "id":38,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"What is true of shaping? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> It works only on outbound traffic.</li><li> It works only on inbound traffic.</li><li> It may drop packets.</li><li> It decreases delay.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Shapers increase delay by queuing packets. Shapers work only on outbound traffic and may drop packets if the shaping queue grows too large."
    },
    {
       "id":39,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"How does configuring low-latency queuing for voice packets reduce packet delay?",
       "choice_a":"Voice packets are placed at the front of the queue.",
       "choice_b":"The LLQ is emptied before other queues.",
       "choice_c":"The LLQ is given unlimited bandwidth.",
       "choice_d":"TCP packets in the LLQ are dropped.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The LLQ is serviced before any other queues, so packets in the LLQ won't wait any longer than necessary. Within the LLQ, the queuing algorithm is FIFO. The LLQ has a limited bandwidth."
    },
    {
       "id":40,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which queuing algorithm is best for TCP-based applications?",
       "choice_a":"LLQ",
       "choice_b":"CBWFQ",
       "choice_c":"FIFO",
       "choice_d":"WRED",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"CBWFQ lets you allocate a set bandwidth to each queue. If there's extra bandwidth available, the queue can exceed it. TCP applications tolerate delay and loss, and adapt to use all available bandwidth, so CBWFQ is the best choice. FIFO (which is the same as no QoS) is not a good choice because of TCP global synchronization. WRED is not a queuing algorithm."
    },
    {
       "id":41,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"With a single, rate, three-color policer, which of the following is true when a packet is violating?",
       "choice_a":"No tokens are removed from any bucket.",
       "choice_b":"Tokens are removed from the bc bucket.",
       "choice_c":"Tokens are removed from the be bucket.",
       "choice_d":"Tokens are removed from both the bc and be buckets.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"When a packet is violating, it's dropped, and no tokens are removed from any bucket."
    },
    {
       "id":42,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which of the following can prevent TCP global synchronization?",
       "choice_a":"WRED",
       "choice_b":"Tail-drop",
       "choice_c":"FIFO",
       "choice_d":"Policing",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"TCP global synchronization occurs when multiple TCP flows back off then ramp up simultaneously. This can happen when a queue fills and excess packets are tail dropped. WRED is an alternative to tail-drop that randomly drops packets as the queue fills."
    },
    {
       "id":43,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"What interface configuration command applies the policy map \u0022mark\u0022 to ingress traffic?",
       "choice_a":"<code>policy-map input mark</code>",
       "choice_b":"<code>class-map input mark</code>",
       "choice_c":"<code>service-policy egress mark</code>",
       "choice_d":"<code>service-policy input mark</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The command <code>service-policy input mark</code> applies the policy map \u0022mark\u0022 to inbound traffic."
    },
    {
       "id":44,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which policy map configuration commands enable CBWFQ with WRED? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>priority</li><li>bandwidth</li><li>random-detect</li><li>fair-queue</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The <code>bandwidth</code> command enables CBWFQ. The <code>random-detect</code> command enables WRED."
    },
    {
       "id":45,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which policy map configuration command enables low-latency queuing?",
       "choice_a":"<code>priority</code>",
       "choice_b":"<code>bandwidth</code>",
       "choice_c":"<code>random-detect</code>",
       "choice_d":"<code>fair-queue</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The <code>priority</code>command enables LLQ."
    },
    {
       "id":46,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Differentiate between on-premises and cloud infrastructure deployments",
       "question":"Which of the following SD-Access fabric node roles can provide connectivity to a public cloud?",
       "choice_a":"Fabric edge node",
       "choice_b":"Fabric border node",
       "choice_c":"Control plane node",
       "choice_d":"Fabric WLAN controller node",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The fabric border node performs route redistribution between IP prefixes that are internal to the fabric and those that are external, such as those in a public cloud environment."
    },
    {
       "id":47,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Differentiate between on-premises and cloud infrastructure deployments",
       "question":"Your SD-WAN consists of a data center and several branch offices. Which of the following must you do to add a cloud environment to your SD-WAN?",
       "choice_a":"Deploy a vEdge router at a branch office",
       "choice_b":"Deploy a vEdge Cloud router at the data center",
       "choice_c":"Deploy a cEdge router into the cloud",
       "choice_d":"Follow the cloud provider's instructions for creating an IPsec VPN",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"To make the cloud a part of your SD-WAN, you can deploy a vEdge cloud router, also called a cEdge router, into your cloud environment."
    },
    {
       "id":48,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-Access solution",
       "question":"Why does SD-Access use VXLAN encapsulation instead of LISP encapsulation?",
       "choice_a":"SD-Access doesn't use VXLAN encapsulation",
       "choice_b":"To extend subnets",
       "choice_c":"To enable IP mobility",
       "choice_d":"To support IPv6",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"SD-Access uses VXLAN encapsulation because it can carry Ethernet frames, whereas LISP encapsulation can't."
    },
    {
       "id":49,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-Access solution",
       "question":"Which of the following is true of the VXLAN header used by SD-Access?",
       "choice_a":"It carries IS-IS traffic.",
       "choice_b":"It contains Group Policy tags.",
       "choice_c":"It's encrypted.",
       "choice_d":"It is a standard VXLAN header.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"SD-Access uses a proprietary VXLAN header that contains scalable group tags, also known as Group Policy tags. The standard VXLAN header doesn't."
    },
    {
       "id":50,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-Access solution",
       "question":"Which of the following was designed for campus networks?",
       "choice_a":"Cisco SD-WAN",
       "choice_b":"Cisco SD-Access",
       "choice_c":"Cisco ACI",
       "choice_d":"Cisco VTS",
       "choice_e":"Cisco SDN Center",
       "correct_answer":"B",
       "explanation":"SD-Access was designed for campus networks. ACI was designed for the data center. VTS is for service providers."
    },
    {
       "id":51,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-Access solution",
       "question":"Which of the following control plane protocols does SD-Access use for route advertisements in the overlay?",
       "choice_a":"OMP",
       "choice_b":"VXLAN",
       "choice_c":"Multicast",
       "choice_d":"LISP",
       "choice_e":"BGP",
       "correct_answer":"D",
       "explanation":"SD-Access uses LISP to store IP routes for the overlay."
    },
    {
       "id":52,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-Access solution",
       "question":"Which of the following components of the SD-Access controller layer provides authentication services?",
       "choice_a":"Network Data Platform",
       "choice_b":"Network Controller Platform",
       "choice_c":"Identity Services Engine",
       "choice_d":"TrustSec",
       "choice_e":"Network access control",
       "correct_answer":"C",
       "explanation":"The Identity Services Engine (ISE) provides network access control, which encompasses authentication and policy enforcement."
    },
    {
       "id":53,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Which of the following are <italic>not</italic> part of Cisco SD-WAN? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> BGP</li><li> vSmart controller</li><li> vBond orchestrator</li><li> vManage NMS</li><li> IPsec</li><li> LISP</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, F",
       "correct_answer":"E",
       "explanation":"SD-WAN doesn't use LISP or BGP. SD-WAN uses OMP, which is a lot like BGP, which is somewhat like LISP. But OMP is not BGP."
    },
    {
       "id":54,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Which of the following networks can SD-WAN work with? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> MPLS</li><li> T1</li><li> Metro Ethernet</li><li> Dedicated Internet access</li></ol>",
       "choice_a":"A, B, C",
       "choice_b":"B, C, D",
       "choice_c":"A, B, D",
       "choice_d":"A, B, C, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"SD-WAN vEdge routers have Ethernet WAN interfaces, so they can work with all of these."
    },
    {
       "id":55,
       "topic_id":1,
       "practice_test_id":2,
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Which SD-WAN component authenticates both vEdge routers and the vSmart controller?",
       "choice_a":"OMP",
       "choice_b":"vManage orchestrator",
       "choice_c":"vManage NMS",
       "choice_d":"vBond orchestrator",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The vBond orchestrator authenticates the vEdge routers and the vSmart controller using a DTLS connection."
    },
    {
       "id":56,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Which of the following is true of SD-WAN?",
       "choice_a":"OMP traffic is tunneled over DTLS.",
       "choice_b":"The <code>default</code> color can be used with MPLS.",
       "choice_c":"The vManage NMS maintains a centralized routing table.",
       "choice_d":"The vSmart controller must be configured manually.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"OMP traffic is tunneled over DTLS."
    },
    {
       "id":57,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Which of the following VPN identifiers is used for SD-WAN router management?",
       "choice_a":"0",
       "choice_b":"1",
       "choice_c":"512",
       "choice_d":"1024",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"VPN 512 is reserved for the management interface."
    },
    {
       "id":58,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the working principles of the Cisco SD-WAN solution",
       "question":"Two vEdge routers are behind NAT firewalls connected to an Internet circuit. Which of the following is required to get them to form a tunnel with each other?",
       "choice_a":"One router must be given a public IP address.",
       "choice_b":"No action is required; the routers will use NAT traversal to establish an IPsec tunnel.",
       "choice_c":"Each router must have a public IP address.",
       "choice_d":"You must configure port forwarding..",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"vEdge routers use NAT traversal techniques to establish an IPsec tunnel through a NAT firewall."
    },
    {
       "id":59,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"Which of the following is required in order for a switch to forward an Ethernet frame?",
       "choice_a":"Destination MAC address",
       "choice_b":"Source MAC address",
       "choice_c":"MAC address table",
       "choice_d":"Destination IP address",
       "choice_e":"Source IP address",
       "correct_answer":"A",
       "explanation":"Ethernet requires a destination MAC address."
    },
    {
       "id":60,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Explain the different design principles used in an enterprise network",
       "question":"The following arguments to the <code>port-channel load-balance</code> configuration command represent EtherChannel load-balancing methods. Which of the following EtherChannel load-balancing methods would be most appropriate for a routed EtherChannel interface?",
       "choice_a":"<code>src-dst-mac</code>",
       "choice_b":"<code>src-dst-ip</code>",
       "choice_c":"<code>src-mac</code>",
       "choice_d":"<code>dst-mac</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Because a routed interface is generally going to have the same two MAC addresses sending and receiving frames, it's unlikely that there will be an even load distribution across the links. It makes more sense to use the <code>src-dst-ip</code> load-balancing method to achieve a load distribution based on the source and destination IP addresses."
    },
    {
       "id":61,
       "topic_id":1,
       "practice_test_id":"",
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Where should packets be marked for classification?",
       "choice_a":"As close to the destination as possible",
       "choice_b":"In the access layer",
       "choice_c":"In the core",
       "choice_d":"As close to the source as possible",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"You want to mark packets as close to the source as possible. In some cases, you may even allow a host to mark its own packets."
    },
    {
       "id":62,
       "topic_id":1,
       "practice_test_id":3,
       "domain":"Architecture",
       "sub_domain":"Analyze design principles of a WLAN deployment",
       "question":"Which modulation scheme offers the highest data rate?",
       "choice_a":"ASK",
       "choice_b":"QAM",
       "choice_c":"QPSK",
       "choice_d":"FSK",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Quadrature amplitude modulation (QAM) offers the highest rate."
    },
    {
       "id":63,
       "topic_id":1,
       "practice_test_id":3,
       "domain":"Architecture",
       "sub_domain":"Analyze design principles of a WLAN deployment",
       "question":"Which of the following measures radio power output?",
       "choice_a":"Hz",
       "choice_b":"SNR",
       "choice_c":"RSSI",
       "choice_d":"EIRP",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Effective isotropic radiated power (EIRP) measures power output."
    },
    {
       "id":64,
       "topic_id":1,
       "practice_test_id":3,
       "domain":"Architecture",
       "sub_domain":"Analyze design principles of a WLAN deployment",
       "question":"What's the formula for wavelength?",
       "choice_a":"Speed of light ´ frequency",
       "choice_b":"Speed of light / frequency",
       "choice_c":"Frequency / speed of light",
       "choice_d":"1 / Frequency / speed of light",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The equation for wavelength is λ = c/f, where λ is wavelength, c is the speed of light (m/s), and f is frequency (Hz)."
    },
    {
       "id":65,
       "topic_id":1,
       "practice_test_id":3,
       "domain":"Architecture",
       "sub_domain":"Analyze design principles of a WLAN deployment",
       "question":"Which is the difference between the RSSI and the noise floor?",
       "choice_a":"Effective Isotropic Radiated Power (EIRP)",
       "choice_b":"Free space path loss",
       "choice_c":"Signal-to-noise ratio",
       "choice_d":"The power differential",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The difference between the received signal strength indicator (RSSI) and the noise floor is called the signal-to-noise ratio (SNR)."
    },
    {
       "id":66,
       "topic_id":1,
       "practice_test_id":3,
       "domain":"Architecture",
       "sub_domain":"Analyze design principles of a WLAN deployment",
       "question":"Which antenna type is most suitable for point-to-point wireless links?",
       "choice_a":"Parabolic",
       "choice_b":"Yagi",
       "choice_c":"Omnidirectional",
       "choice_d":"Isotropic",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Parabolic dishes are usually used on dedicated point-to-point wireless links such as those between two buildings or between a building and a tower. Parabolic antennas can have a gain of up to 30 dBi or higher."
    },
    {
       "id":67,
       "topic_id":1,
       "practice_test_id":3,
       "domain":"Architecture",
       "sub_domain":"Describe concepts of wired and wireless QoS",
       "question":"Which of the following prevents network congestion?",
       "choice_a":"Queuing",
       "choice_b":"Sufficient bandwidth",
       "choice_c":"Shaping",
       "choice_d":"Weighted random early detection",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"If you have enough bandwidth, you don't need quality of service (QoS). Queuing and weighted random early detection (WRED) kick in after congestion has already occurred. Shaping introduces delays to avoid packet loss at the price of potentially causing congestion."
    },
    {
       "id":68,
       "topic_id":2,
       "practice_test_id":1,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"What is another term for reflective relay?",
       "choice_a":"Virtual network function",
       "choice_b":"Virtual Ethernet bridge",
       "choice_c":"Virtual switching",
       "choice_d":"External edge virtual bridging",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The term edge virtual bridging (EVB) describes using a physical switch to pass layer 2 traffic between VMs running on the same host. The IEEE 802.1Qbg standard calls this reflective relay."
    },
    {
       "id":69,
       "topic_id":2,
       "practice_test_id":1,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which of the following might you need to allow in order to use IPsec in transport mode? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> TCP port 50</li><li> IP protocol 50</li><li> UDP port 500</li><li> IP protocol 51</li><li> IP protocol 41</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, D",
       "correct_answer":"B",
       "explanation":"Internet Key Exchange (IKE) uses User Datagram Protocol (UDP) port 500, whereas Encapsulating Security Payload (ESP) uses IP protocol 50."
    },
    {
       "id":70,
       "topic_id":2,
       "practice_test_id":1,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"By default, what does VXLAN use for MAC address learning? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Multicast</li><li> EVPN</li><li> Data plane learning</li><li> Control plane learning</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"By default, Virtual Extensible LAN (VXLAN) uses multicast to flood unknown unicasts, allowing it to perform data plane learning."
    },
    {
       "id":71,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Describe device virtualization technologies",
       "question":"Which two of the following are commonly considered type-1 hypervisors? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Oracle VirtualBox</li><li> VMware ESXi</li><li> KVM</li><li> VMware Fusion</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Some type-1 hypervisors are VMware ESXi, Microsoft Hyper-V, KVM, and Xen."
    },
    {
       "id":72,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Describe device virtualization technologies",
       "question":"Which of the following best describes a type-1 hypervisor?",
       "choice_a":"Costs money",
       "choice_b":"Runs without an operating system",
       "choice_c":"Contains a robust user-friendly interface",
       "choice_d":"Designed to run on server hardware",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Type-1 hypervisors are specially geared toward running virtual machines on server hardware. Type-1 hypervisors are for server virtualization and don't have a lot of bells and whistles."
    },
    {
       "id":73,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"What virtual network device does a hypervisor include to enable VMs to communicate with one another and the outside world?",
       "choice_a":"Network overlay",
       "choice_b":"Virtual network function",
       "choice_c":"Virtual router",
       "choice_d":"Virtual switch",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Hypervisors provide a virtual switch that virtual machines use to communicate with other VMs on the same host, as well as network devices outside of the VM host."
    },
    {
       "id":74,
       "topic_id":2,
       "practice_test_id":2,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which two of the following features enable an external physical switch to pass traffic between VMs that are running on the same host? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Reflective relay</li><li> Internal edge virtual bridging</li><li> External edge virtual bridging</li><li> Virtual Ethernet bridge</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The term edge virtual bridging (EVB) describes using a physical switch to pass layer 2 traffic between VMs running on the same host. In external edge virtual bridging, traffic from one VNF goes out of the physical NIC to a physical switch and then comes back into the same NIC. The IEEE 802.1Qbg standard calls this reflective relay."
    },
    {
       "id":75,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What will prevent a GRE tunnel from forming?",
       "choice_a":"The absence of an IPv4 address on the tunnel interface",
       "choice_b":"An access list that blocks IP protocol 47",
       "choice_c":"An access list that blocks UDP",
       "choice_d":"Failing to specify the tunnel mode",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Anything that blocks IP protocol 47 is going to block a GRE tunnel from forming."
    },
    {
       "id":76,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which two of the following are valid uses of GRE tunnels? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Virtual private networks</li><li> IPv6 over IPv4</li><li> MAC over IPv4</li><li> MAC over IPv6</li><li> Reducing the size of routing tables</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, D",
       "correct_answer":"A",
       "explanation":"Generic routing encapsulation (GRE) allows you to tunnel almost any layer 3 protocol over another. GRE is typically used to form a site-to-site virtual private network (VPN) tunnel when combined with IPsec."
    },
    {
       "id":77,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"You want to create an OSPFv2 adjacency over an existing GRE tunnel. Which of the following must you do?",
       "choice_a":"Disable IPsec",
       "choice_b":"Enable OSPF on the physical interfaces",
       "choice_c":"Enable OSPF on the tunnel interfaces",
       "choice_d":"Set the router IDs",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"You just need to enable OSPF on the tunnel interfaces. There's no requirement to explicitly set router IDs in OSPFv2, although it's a good idea. There's no need to enable OSPF on the physical interface to enable it over the tunnel, nor is there any need to disable IPsec."
    },
    {
       "id":78,
       "topic_id":2,
       "practice_test_id":2,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which of the following can cause recursive routing when using GRE?",
       "choice_a":"Advertising the tunnel interface over the physical interface being used as the tunnel endpoint",
       "choice_b":"Advertising tunnel endpoint prefixes over the tunnel",
       "choice_c":"Advertising the tunnel interface over the tunnel",
       "choice_d":"Having a static route to the tunnel endpoint",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Recursive routing occurs when a route to tunnel endpoint uses the tunnel interface itself as the next hop. This can happen when you use the same routing protocol to advertise tunnel endpoint prefixes over both the tunnel and the physical interfaces used for the tunnel endpoints."
    },
    {
       "id":79,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"When configuring IPsec, what's the minimum Diffie-Hellman group number should you use for ISAKMP?",
       "choice_a":2,
       "choice_b":14,
       "choice_c":2048,
       "choice_d":19,
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The minimum acceptable DH group number is 14, which provides a 2,048-bit key size."
    },
    {
       "id":80,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What protocol and port does Internet Key Exchange (IKE) use?",
       "choice_a":"UDP/50",
       "choice_b":"TCP/50",
       "choice_c":"UDP/500",
       "choice_d":"TCP/500",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"IKE uses UDP/500."
    },
    {
       "id":81,
       "topic_id":2,
       "practice_test_id":2,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What protocol does Encapsulating Security Payload (ESP) use?",
       "choice_a":"IP protocol 50",
       "choice_b":"UDP",
       "choice_c":"TCP",
       "choice_d":"IP protocol 47",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"ESP uses IP protocol 47."
    },
    {
       "id":82,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which of the following commands will tell you whether an IPsec tunnel under interface Tunnel0 is using tunnel or transport mode?",
       "choice_a":"<code>show crypto isakmp sa</code>",
       "choice_b":"<code>show interface tunnel0</code>",
       "choice_c":"<code>show crypto ipsec sa</code>",
       "choice_d":"<code>show crypto ipsec profile</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"<code>show crypto ipsec sa</code> will show the IPsec ESP security associations details, including whether tunnel or transport mode is being used."
    },
    {
       "id":83,
       "topic_id":2,
       "practice_test_id":4,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What protocol and port does LISP use for tunneling IP packets?",
       "choice_a":"UDP/4341",
       "choice_b":"UDP/4342",
       "choice_c":"UDP/4789",
       "choice_d":"UDP/47",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"LISP uses UDP/4341 for tunneling packets."
    },
    {
       "id":84,
       "topic_id":2,
       "practice_test_id":5,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which LISP router configuration command maps the EID <code>172.16.3.3/32</code> to the RLOC <code>10.10.10.1</code>?",
       "choice_a":"<code>database-mapping 172.16.3.3/32 auto-discover-rlocs</code>",
       "choice_b":"<code>rloc-mapping 172.16.3.3/32 10.10.10.1 priority 1 weight 1</code>",
       "choice_c":"<code>database-mapping 10.10.10.1 172.16.3.3/32 priority 1 weight 1</code>",
       "choice_d":"<code>database-mapping 172.16.3.3/32 10.10.10.1 priority 1 weight 1</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The command <code>database-mapping 172.16.3.3/32 10.10.10.1 priority 1 weight 1 </code>will map the EID <code>172.16.3.3/32</code> to the RLOC <code>10.10.10.1. </code>"
    },
    {
       "id":85,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Consider the following LISP Internet Groper (LIG) output: <br> <code>xTR2(config)#do lig 172.16.3.3</code> <br> <code>Mapping information for EID 172.16.3.3 from 10.10.10.1 with RTT 17 msecs</code> <br> <code>172.16.3.3/32, uptime: 00:04:31, expires: 23:59:59, via map-reply, self, complete</code> <br> <code>Locator     Uptime    State      Pri/Wgt</code> <br> <code>10.10.10.1  00:04:31  up           1/1</code> <br> <code>10.10.30.2  00:03:32  admin-down 255/1 </code> <br>What can you infer from the output? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> 10.10.10.1 is the RLOC for 172.16.3.3/32 </li><li>172.16.3.3/32 isn't reachable via 10.10.10.1 </li><li>172.16.3.3/32 doesn't exist in xTR2's IP routing table</li><li> xTR2 doesn't have an EID-to-RLOC mapping configured</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The output indicates that <code>172.16.3.3/32</code> is reachable via <code>10.10.10.1</code> (xTR1). The <code>admin-down</code> flag next to <code>10.10.10.2 </code> (xTR2) indicates that xTR2 has registered a negative map entry for the EID because it doesn't have an IP route to <code>172.16.3.3/32. </code>"
    },
    {
       "id":86,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What two techniques does LISP use to reduce the size of IP routing tables? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> BGP summarization</li><li> Tunneling</li><li> Encapsulation</li><li> IP mobility</li></ol>",
       "choice_a":"A, C",
       "choice_b":"B, C",
       "choice_c":"A, C",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"LISP encapsulates IP packets (with source and destination EIDs) to create a tunnel between ITRs and ETRs. Because the EIDs are encapsulated, intermediate routers don't need to maintain routes for them."
    },
    {
       "id":87,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What protocol and port does VXLAN use?",
       "choice_a":"TCP/4789",
       "choice_b":"UDP/4341",
       "choice_c":"UDP/4342",
       "choice_d":"UDP/4789",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"VXLAN uses UDP/4789."
    },
    {
       "id":88,
       "topic_id":2,
       "practice_test_id":2,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"What are two options for MAC address learning in VXLAN? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Broadcast</li><li> Flood-and-learn</li><li> OSPF</li><li> EVPN</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Flood-and-learn with multicast, EVPN with BGP, and LISP are options for MAC address learning with VXLAN."
    },
    {
       "id":89,
       "topic_id":2,
       "practice_test_id":4,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Where do you map a VXLAN VNI to a multicast group address?",
       "choice_a":"Network virtualization edge (NVE) configuration",
       "choice_b":"Switched interface configuration",
       "choice_c":"VLAN configuration",
       "choice_d":"PIM configuration",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"You map the VNI to a multicast group under the NVE configuration. For example, to map VNI <code>10050</code> to <code>230.1.1.1, </code> you'd use the command <code>member vni 10050 mcast-group 230.1.1.1. </code>"
    },
    {
       "id":90,
       "topic_id":2,
       "practice_test_id":5,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which of the following set of commands map VLAN <code>50</code> to VNI <code>10050</code>? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> vn-segment 10050 </li><li>vlan 50</li><li>member vni 10050</li><li>switchport mode access vlan 50</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"To map VLAN <code>50</code> to VNI <code>10050</code>, for example, you'd use the following set of commands: <br> <code>Nexus(config)# vlan 50</code> <br> <code>Nexus(config-vlan)# vn-segment 10050</code>"
    },
    {
       "id":91,
       "topic_id":2,
       "practice_test_id":"",
       "domain":"Virtualization",
       "sub_domain":"Describe device virtualization technologies",
       "question":"Which of the following is true of VRFs?",
       "choice_a":"A physical interface can be a member of multiple VRFs.",
       "choice_b":"VRFs can have overlapping routes.",
       "choice_c":"You must configure an IP address on an interface before adding it to a VRF.",
       "choice_d":"VRF names must be globally unique.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The advantage of VRFs is that you have completely separate and independent IP routing tables and FIBs, so having overlapping routes is permitted."
    },
    {
       "id":92,
       "topic_id":2,
       "practice_test_id":2,
       "domain":"Virtualization",
       "sub_domain":"Describe device virtualization technologies",
       "question":"Which interface command adds an interface to VRF Green?",
       "choice_a":"<code>address-family ipv4 vrf Green</code>",
       "choice_b":"<code>ip vrf forwarding Green</code>",
       "choice_c":"<code>ip vrf Green</code>",
       "choice_d":"<code>ip forwarding Green</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The command to add an interface to VRF Green is <code>ip vrf forwarding Green. </code>"
    },
    {
       "id":93,
       "topic_id":2,
       "practice_test_id":4,
       "domain":"Virtualization",
       "sub_domain":"Describe device virtualization technologies",
       "question":"Which set of commands enables EIGRP AS 10 for VRF Yellow?",
       "choice_a":"<code>router eigrp 10</code> <br> <code>address-family ipv4 vrf Yellow</code> <br> <code>network 0.0.0.0 0.0.0.0</code>",
       "choice_b":"<code>router eigrp 10</code> <br> <code>address-family ipv4 vrf Yellow</code> <br> <code>autonomous-system vrf</code> <br> <code>network 0.0.0.0 0.0.0.0</code>",
       "choice_c":"<code>router eigrp 10</code> <br> <code>address-family ipv4 vrf Yellow</code> <br> <code>autonomous-system 10</code> <br> <code>network 0.0.0.0 0.0.0.0 vrf</code>",
       "choice_d":"<code>router eigrp 11</code> <br> <code>address-family ipv4 vrf Yellow</code> <br> <code>autonomous-system 10</code> <br> <code>network 0.0.0.0 0.0.0.0</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"You must specify the AS number under the address family configuration. The AS number in the <code>router eigrp </code>command doesn't specify the AS number used in the VRF."
    },
    {
       "id":94,
       "topic_id":2,
       "practice_test_id":5,
       "domain":"Virtualization",
       "sub_domain":"Describe device virtualization technologies",
       "question":"Which command will show the IP routing table for VRF Orange?",
       "choice_a":"<code>show ip route vrf Orange</code>",
       "choice_b":"<code>show ip vrf</code>",
       "choice_c":"<code>show ip route</code>",
       "choice_d":"<code>show ip vrf route Orange</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"<code>show ip route vrf Orange</code> will show the IP routing table for VRF Orange."
    },
    {
       "id":95,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which three commands will enable OSPFv3 on interface <code>Gi0/1</code> with an IP address of <code>1.1.1.1/32</code> and an IPv6 address of <code>2001:db8::1/64</code>? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>interface gi0/1 </li><li>router ospfv3 1</li><li> network 1.1.1.1 0.0.0.0 area 0</li><li>ospfv3 1 ipv6 area 0</li><li>ipv6 ospf area 0</li><li>router-id 1.1.1.1</li></ol>",
       "choice_a":"A, B, C",
       "choice_b":"B, C, D",
       "choice_c":"C, D, E",
       "choice_d":"D, E, F",
       "choice_e":"A, D, F",
       "correct_answer":"E",
       "explanation":"Open Shortest Path First version 3 (OSPFv3) works only with IPv6, and it requires a router ID (RID) to be explicitly set. To enable OSPFv3 on interface <code>Gi0/1</code>, issue the interface command <code>ospfv3 1 ipv6 area 0</code>."
    },
    {
       "id":96,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Configure and verify data path virtualization technologies",
       "question":"Which three things are true of the following configuration? <br> <code>interface Tunnel12</code> <br>  <code>ip address 12.12.12.2 255.255.255.252</code> <br>  <code>ipv6 address 2001:DB8:12::2/64</code> <br> <code>ospfv3 1 ipv6 area 0</code> <br>  <code>tunnel source 10.10.30.2</code> <br> <code>tunnel mode ipsec ipv4</code> <br> <code>tunnel destination 10.10.10.1</code> <br> <code>tunnel protection ipsec profile myprofile</code> <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> The overlay is IPv6.</li><li> The underlay is IPv6.</li><li> The overlay is IPv4.</li><li> The underlay is IPv4.</li><li> The underlay is encrypted.</li><li> OSPFv3 is running on the underlay.</li></ol>",
       "choice_a":"A, B, C",
       "choice_b":"B, C, D",
       "choice_c":"C, D, E",
       "choice_d":"D, E, F",
       "choice_e":"A, C, D",
       "correct_answer":"E",
       "explanation":"The overlay is both IPv4 and IPv6, since the tunnel interface is configured with both address families. The underlay is IPv4, as shown by the tunnel source and destination being IPv4."
    },
    {
       "id":97,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which of the following is true of LISP?",
       "choice_a":"An ingress tunnel router decapsulates LISP packets.",
       "choice_b":"LISP packets are sent to an EID.",
       "choice_c":"LISP routes do not appear in the IP routing table.",
       "choice_d":"LISP packets are encapsulated in VXLAN packets by default.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"LISP routes do not appear in the IP routing table."
    },
    {
       "id":98,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which LISP command will advertise a map entry to a map server?",
       "choice_a":"<code>database-mapping 172.16.3.3/32 auto-discover-rlocs</code>",
       "choice_b":"<code>database-mapping 172.16.3.3/32 10.10.30.2 priority 1 weight 1</code>",
       "choice_c":"<code>ipv4 itr map-resolver 10.10.30.10</code>",
       "choice_d":"<code>ipv4 etr map-server 10.10.10.10 key mysecret</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The command to advertise an endpoint ID to routing locator (EID-to-RLOC) database mapping to a map server is <code>database-mapping 172.16.3.3/32 10.10.30.2 priority 1 weight 1</code>, where the EID is <code>172.16.3.3/32</code> and the RLOC is <code>10.10.30.2</code>."
    },
    {
       "id":99,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which command will display the forwarding information for a LISP EID <code>172.16.3.3</code>?",
       "choice_a":"<code>show ip cef lisp eid remote 172.16.3.3</code>",
       "choice_b":"<code>show ip cef 172.16.3.3</code>",
       "choice_c":"<code>show ip route 172.16.3.3</code>",
       "choice_d":"<code>show ip lisp eid 172.16.3.3</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The command that will show forwarding information for LISP endpoint ID (EID) <code>172.16.3.3</code> is <code>show ip cef lisp eid remote 172.16.3.3. </code>"
    },
    {
       "id":100,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which of the following may appear in the IP routing table of a LISP router? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> RLOC</li><li> Remote EID</li><li> Local EID</li><li> VTEP</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"A routing locator (RLOC) and local endpoint ID (EID) may appear in the IP routing table of a LISP router. A remote EID will never appear. Virtual Tunnel End Point (VTEP) is a Virtual Extensible LAN (VXLAN) term and unrelated to LISP."
    },
    {
       "id":101,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which of the following will you <italic>not</italic> find in a router that is <italic>not</italic> a LISP ITR or ETR?",
       "choice_a":"EID-to-RLOC mapping",
       "choice_b":"Map resolver's IP address in the IP routing table",
       "choice_c":"EID address in the IP routing table",
       "choice_d":"RLOC address in the IP routing table",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"A LISP map server may contain an endpoint ID to routing locator (EID-to-RLOC) mapping and have the IP addresses of a map resolver and RLOC in its IP routing table. It will not, however, have an EID in its IP routing table unless it's an egress tunnel router (ETR) or ingress tunnel router (ITR)."
    },
    {
       "id":102,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"What does VXLAN use to forward known unicasts?",
       "choice_a":"Multicast",
       "choice_b":"Unicast",
       "choice_c":"Broadcast",
       "choice_d":"LISP",
       "choice_e":"EVPN",
       "correct_answer":"B",
       "explanation":"Virtual Extensible LAN (VXLAN) by default forwards known unicasts to a VXLAN tunnel endpoint's (VTEP) unicast IP address. LISP or Ethernet VPN (EVPN) can be used for MAC address learning but aren't used for forwarding."
    },
    {
       "id":103,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"Which of the following provides end-to-end encryption between routers?",
       "choice_a":"GRE",
       "choice_b":"Authentication header",
       "choice_c":"Encapsulating Security Payload",
       "choice_d":"MACsec",
       "choice_e":"TrustSec",
       "correct_answer":"C",
       "explanation":"IPsec uses the Encapsulating Security Payload (ESP) protocol to provide encryption and authentication."
    },
    {
       "id":104,
       "topic_id":2,
       "practice_test_id":3,
       "domain":"Virtualization",
       "sub_domain":"Describe network virtualization concepts",
       "question":"What is one reason for creating an IPv4 over IPv4 tunnel?",
       "choice_a":"To enable IPv6",
       "choice_b":"To extend a subnet",
       "choice_c":"To send unicast traffic over a VXLAN",
       "choice_d":"To send multicast traffic over a unicast-only underlay",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"An IPv4 over IPv4 tunnel is useful for sending multicast traffic over an underlay that supports only unicast traffic."
    },
    {
       "id":105,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"IP depends on which of the following?",
       "choice_a":"Address Resolution Protocol",
       "choice_b":"Data link layer",
       "choice_c":"Network layer",
       "choice_d":"Transport layer",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The Data Link layer facilitates data transfer between two nodes. IP addresses are logical addresses based on an abstraction of the Data Link layer."
    },
    {
       "id":106,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which is <italic>not</italic> a function of a bridge?",
       "choice_a":"Simulating some properties of a shared physical Ethernet cable",
       "choice_b":"MAC-based routing",
       "choice_c":"Reducing the size of a broadcast domain",
       "choice_d":"Frame check sequence validation",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"A bridge maintains a Media Access Control (MAC) address table that it uses to perform a crude form of routing. This reduces the need for flooding but doesn't reduce the size of the broadcast domain. Bridges forward received frames, thus simulating some of the properties of a shared physical Ethernet cable. Bridges discard frames that fail frame check sequence validation."
    },
    {
       "id":107,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What are the purposes of TCP sequence numbers? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Error control</li><li> Ordering</li><li> Flow control</li><li> Reliable delivery</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"B, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Transmission Control Protocol (TCP) uses sequence numbers for ordering and ensuring reliable delivery by detecting lost packets."
    },
    {
       "id":108,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Three switches are connected via 802.1Q trunk links. You need to prevent VLAN 25 traffic from reaching two of the switches. Which of the following can accomplish this? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Prune VLAN 25 on the trunk links.</li><li> Use routed interfaces instead of trunks.</li><li> Configure Spanning Tree to block the ports to the switches.</li><li> Delete VLAN 25 on the switches.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"You can block VLAN 25 from reaching the switches in two ways. First, you can prune the virtual LAN (VLAN) from the trunk. Second, instead of running a trunk between switches, you can use routed links."
    },
    {
       "id":109,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Switch SW1 is running RPVST+ and is connected via a routed interface to SW2, which is running Multiple Spanning Tree. If you add VLAN 2 to both switches and map VLAN 2 to <code>MST1</code> on SW2, which switch will necessarily be the root for VLAN 2?",
       "choice_a":"SW1",
       "choice_b":"SW2",
       "choice_c":"The switch with the lowest bridge priority",
       "choice_d":"Both SW1 and SW2",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Because SW1 and SW2 are connected via routed interfaces, they are in separate broadcast domains and hence form separate Spanning Trees."
    },
    {
       "id":110,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following can effectively prune a VLAN from a trunk?",
       "choice_a":"BPDU Guard",
       "choice_b":"BPDU Filter",
       "choice_c":"Loop Guard",
       "choice_d":"UDLD",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Loop Guard will block a VLAN on a port if it doesn't receive Bridge Protocol Data Units (BPDUs) for that VLAN. Unidirectional Link Detection (UDLD) and BPDU Guard can shut down an entire port. BPDU Filter doesn't block traffic."
    },
    {
       "id":111,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What are two reasons to choose a routed topology over a switched topology? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Better scalability</li><li> Better use of IP address space</li><li> The ability to stretch subnets</li><li> Faster convergence</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"A, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Routed topologies scale better and converge faster than switched topologies, but they require consuming more IP address space."
    },
    {
       "id":112,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which protocol does not use multicast?",
       "choice_a":"LACP",
       "choice_b":"EtherChannel",
       "choice_c":"VRRP",
       "choice_d":"HSRP",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"EtherChannel doesn't use multicast. Link Aggregation Control Protocol (LACP), which negotiates EtherChannels, and Virtual Router Redundancy Protocol (VRRP) and Hot Standby Router Protocol (HSRP), which are first-hop redundancy protocols (FHRPs), do use multicast."
    },
    {
       "id":113,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Wireless",
       "question":"An access point running in lightweight mode has clients connected to two SSIDs. The total number of connected clients is 25. How many CAPWAP tunnels are there between the AP and its WLAN controller (WLC)?",
       "choice_a":1,
       "choice_b":2,
       "choice_c":25,
       "choice_d":"Lightweight mode doesn't use a WLC.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"An access point (AP) forms a single Control and Provisioning of Wireless Access Points (CAPWAP) tunnel with a wireless LAN controller (WLC)."
    },
    {
       "id":114,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Wireless",
       "question":"What are two disadvantages of 5 GHz Wi-Fi versus 2.4 GHz Wi-Fi? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Incompatibility with 802.11g</li><li> Incompatibility with 802.11n</li><li> Increased free space path loss</li><li> Lower throughput</li></ol>",
       "choice_a":"A, B",
       "choice_b":"C, D",
       "choice_c":"A, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"5.4 GHz Wi-Fi standards include 802.11n and 802.11ac, but not 802.11g. 5.4 GHz offers higher throughput, but at the price of increased free space path loss."
    },
    {
       "id":115,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"There are three OSPF routers connected to the same subnet. Which is the designated router?",
       "choice_a":"The one with the lowest router ID",
       "choice_b":"The first one that became active",
       "choice_c":"The one with the highest router ID",
       "choice_d":"The one with the highest priority",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The first Open Shortest Path First (OSPF) router to becomes active on a subnet becomes the designated router (DR) for the subnet. It's commonly taught that the DR is chosen based on the highest router ID, but the first OSPF router to become active always becomes the DR. A DR election occurs only when the existing DR and backup DR fail."
    },
    {
       "id":116,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Two OSPF routers are connected to each other. One router's interface is configured as a broadcast network type, whereas the other router's interface is configured as a point-to-point network type. Which of the following is true of this configuration? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> They won't form an adjacency.</li><li> They will form an adjacency.</li><li> They won't exchange routes.</li><li> They will exchange routes.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Network types don't have to match in order to form an adjacency, but they do need to match in order for the routers to exchange routes."
    },
    {
       "id":117,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"You have a router with an interface that's connected to a subnet dedicated to servers. You want to advertise this subnet into OSPF but don't want any servers running OSPF software to form an adjacency with the router. How can you accomplish this?",
       "choice_a":"Configure null authentication.",
       "choice_b":"Use a distribute list.",
       "choice_c":"Advertise a default route.",
       "choice_d":"Configure the interface as a passive interface.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"When an interface is configured as a passive interface, OSPF will advertise the prefix for that interface, but will not form an adjacency with other routers on the subnet."
    },
    {
       "id":118,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"An OSPF autonomous system boundary router (ASBR) is redistributing the prefix <code>192.168.0.0/16</code> into EIGRP AS 1. What is the administrative distance of the route?",
       "choice_a":20,
       "choice_b":110,
       "choice_c":170,
       "choice_d":200,
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The route is an external Enhanced Interior Gateway Routing Protocol (EIGRP) route, so it has an administrative distance of 170."
    },
    {
       "id":119,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following are considered in calculating an EIGRP metric? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Bandwidth</li><li> Delay</li><li> MTU</li><li> Reliability</li><li> Latency</li><li> Weight</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"E, F",
       "correct_answer":"A",
       "explanation":"By default, only bandwidth and delay are used in calculating the metric."
    },
    {
       "id":120,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following EIGRP output. <br> <code>P 10.0.36.0/29, 1 successors, FD is 3328</code> <br> <code>via 10.0.45.4 (3328/3072), GigabitEthernet0/3.</code> <br> <code>via 10.0.56.6 (5632/2816), GigabitEthernet0/0.</code> <br>Which of the following is the feasible successor?",
       "choice_a":"<code>10.0.36.1</code>",
       "choice_b":"<code>10.0.56.6</code>",
       "choice_c":"<code>10.0.45.4</code>",
       "choice_d":"<code>10.0.36.2</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"<code>10.0.56.6</code> is the feasible successor."
    },
    {
       "id":121,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What occurs when an eBGP router receives a route for that already has its own AS number in the path?",
       "choice_a":"Removes the AS and advertises the route",
       "choice_b":"Advertises the route as is",
       "choice_c":"Discards the route",
       "choice_d":"Installs the route in its BGP RIB",
       "choice_e":"Discards all routes from the router it received the route from",
       "correct_answer":"C",
       "explanation":"Border Gateway Protocol (BGP) uses the autonomous system (AS) path for loop prevention. Upon receiving a route with its own AS in the AS path, an exterior Border Gateway Protocol (eBGP) router will discard the route, meaning it won't install it in its BGP Routing Information Base (RIB) or IP routing table, nor will it advertise the route."
    },
    {
       "id":122,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"R1 has the prefix <code>172.16.0.0/16</code> in its IP routing table, learned from EIGRP AS 16. There are no other BGP, IGP, or static routes in the routing table. You execute the following BGP router configuration commands on R1: <br> <code>network 172.16.0.0 mask 255.255.255.0</code> <br> <code>redistribute eigrp 16</code> <br>Which of the following will be true regarding the route R1 advertises for the <code>172.16.0.0/16</code> prefix?",
       "choice_a":"<code>172.16.0.0/16</code> will have an incomplete origin type.",
       "choice_b":"<code>172.16.0.0/24</code> will have an incomplete origin type.",
       "choice_c":"R1 will not advertise the <code>172.16.0.0/16</code> prefix.",
       "choice_d":"<code>172.16.0.0/16</code> will have an IGP origin type.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"<code>172.16.0.0/24</code> doesn't exist in R1's routing table, so the <code>network</code> command will have no effect. Instead, the <code>redistribute eigrp 16</code> command will redistribute the <code>172.16.0.0/16</code> prefix into BGP with an incomplete origin type."
    },
    {
       "id":123,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following prefix list and route map on router R1: <br> <code>ip prefix-list all-private: 3 entries</code> <br> <code>seq 5 permit 10.0.0.0/8 le 32</code> <br> <code>seq 10 deny 0.0.0.0/0 le 32</code> <br> <code>route-map allow-public, deny, sequence 10</code> <br> <code>Match clauses: </code> <br> <code>ip address prefix-lists: all-private</code> <br> <code>Set clauses: </code> <br> <code>Policy routing matches: 0 packets, 0 bytes</code> <br> <code>route-map R4, permit, sequence 20</code> <br> <code>Match clauses: </code> <br>   <code>Set clauses: </code> <br> <code>Policy routing matches: 0 packets, 0 bytes</code> <br>Which prefix will this route map allow?",
       "choice_a":"<code>10.255.255.0/24</code>",
       "choice_b":"<code>10.0.0.0/32</code>",
       "choice_c":"<code>10.0.0.0/8</code>",
       "choice_d":"<code>0.0.0.0/0</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The prefix list matches any prefix with a subnet falling into the <code>10.0.0.0/8</code> range with a prefix length from 8 to 32. This includes <code>10.0.0.0/8, 10.0.0.0/32, </code> and <code>10.255.255.0/24. </code> The first sequence in the route map is a deny sequence that matches the IP prefix list. Hence, these prefixes will match the sequence and will be denied. The second sequence in the route map is a permit sequence that matches all prefixes that don't match the first sequence."
    },
    {
       "id":124,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Consider the following output from a NAT router: <br> <code>R2#debug ip nat</code> <br> <code>IP NAT debugging is on</code> <br> <code>R2#</code> <br> <code>NAT*: s=7.0.0.12->2.0.0.2, d=10.0.12.1 [155] </code> <br>Which of the following is the inside global address?",
       "choice_a":"<code>2.0.0.2</code>",
       "choice_b":"<code>10.0.12.1</code>",
       "choice_c":"<code>7.0.0.12</code>",
       "choice_d":"<code>10.0.12.155</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"R2 is translating the source address <code>7.0.0.12</code> to <code>2.0.0.2; </code> therefore <code>7.0.0.12</code> is the inside local address and <code>2.0.0.2</code> is the inside global address."
    },
    {
       "id":125,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"A router running PIM has a single multicast RIB entry marked <code> (223.3.2.1, 239.8.7.6) </code>. What does this indicate?",
       "choice_a":"The router has received an IGMP Membership Report from <code>223.3.2.1. </code>",
       "choice_b":"<code>239.8.7.6</code> has sent unicast traffic to <code>223.3.2.1. </code>",
       "choice_c":"<code>223.3.2.1</code> has sent multicast traffic to <code>239.8.7.6. </code>",
       "choice_d":"The router has received a PIM Join/Graft from <code>223.3.2.1. </code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Multicast RIB entries take the form <code>(source, group). </code>The entry indicates that the source-<code>223.3.2.1</code>-has sent multicast traffic to the multicast group address <code>239.8.7.6. </code>"
    },
    {
       "id":126,
       "topic_id":3,
       "practice_test_id":1,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following commands individually configures port address translation?",
       "choice_a":"<code>ip nat inside source list 1 pool natpool</code>",
       "choice_b":"<code>ip nat inside destination list 1 pool natpool overload</code>",
       "choice_c":"<code>ip nat outside source list 1 pool natpool overload</code>",
       "choice_d":"<code>ip nat inside source list 1 interface gi0/2 overload</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Port address translation-also known as network address translation (NAT) overload-translates multiple <code>inside</code> local <code>source</code> addresses to a single global address. The global address can come from an outside interface or from a pool."
    },
    {
       "id":127,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What protocol operates at the Data Link layer?",
       "choice_a":"IPv4",
       "choice_b":"OSPF",
       "choice_c":"PPP",
       "choice_d":"UDP",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"PPP is a Data Link layer protocol. IPv4 and OSPF are Network layer protocols. UDP is a Transport layer protocol."
    },
    {
       "id":128,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Protocols at what layer provide for node-to-node data transfer over a shared medium?",
       "choice_a":"Physical",
       "choice_b":"Data Link",
       "choice_c":"Network",
       "choice_d":"Transport",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Data Link layer protocols such as Ethernet and PPP provide for node-to-node data transfer over a shared medium."
    },
    {
       "id":129,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Workstation A is connected to a switch port that's in VLAN 10. Workstations B and C are connected switch ports in VLAN 20 on the same switch. Both workstations are configured with IP addresses in the 172.16.7.0/24 range. How many broadcast domains are there?",
       "choice_a":"0",
       "choice_b":"1",
       "choice_c":"2",
       "choice_d":"20",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"VLAN 10 is one broadcast domain, and VLAN 20 is another."
    },
    {
       "id":130,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"A server is connected to a switch. Both the server's network interface card (NIC) and the switch port are configured for full-duplex communication. How many collision domains are there?",
       "choice_a":"0",
       "choice_b":"1",
       "choice_c":"2",
       "choice_d":"3",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"A collision domain is where two nodes transmitting simultaneously will interfere with each other. In full-duplex communication, both nodes can transmit simultaneously."
    },
    {
       "id":131,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What is an Ethernet interface MTU?",
       "choice_a":"The minimum size of an Ethernet frame",
       "choice_b":"The maximum size of an Ethernet frame",
       "choice_c":"The speed of an Ethernet interface",
       "choice_d":"The maximum size of the Data field in an Ethernet frame",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The interface MTU is the maximum size of the Data field in an Ethernet frame, measured in bytes."
    },
    {
       "id":132,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What does ARP do?",
       "choice_a":"Maps MAC addresses to IP addresses",
       "choice_b":"Maps MAC addresses to interfaces",
       "choice_c":"Maps IP addresses to MAC addresses",
       "choice_d":"Maps IP addresses to interfaces",
       "choice_e":"Maps MAC addresses to VLANs",
       "correct_answer":"C",
       "explanation":"ARP maps IP addresses to MAC addresses by broadcasting an ARP request with the IP address to resolve. The node that has that IP address sends a unicast ARP reply that contains its MAC address."
    },
    {
       "id":133,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Client A in VLAN 3 has the IP address 172.16.3.3/24. Server A in VLAN 4 has the IP address 172.16.3.10/24. What will occur if client A attempts to ping Server A? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> The ping will succeed.</li><li> Client A will send an ARP request for 172.16.3.10.</li><li> The ping will fail.</li><li> Server A will send an ARP reply.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Client A and Server A are in separate VLANs, but because both share the same IP subnet (172.16.3.0/24), Client A assumes Server A is in the same broadcast domain. Client A therefore sends an ARP request. Server A doesn't receive the request because it's in a different broadcast domain. Without getting an ARP reply, Client A can't even send the ping."
    },
    {
       "id":134,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What destination address is an ARP request sent to?",
       "choice_a":"The MAC address 0000.0000.0000",
       "choice_b":"The MAC address FFFF.FFFF.FFFF",
       "choice_c":"The MAC address 0100.5E01.0001",
       "choice_d":"The IP address 255.255.255.255",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"ARP requests are sent to the broadcast MAC address. They are not sent using IP."
    },
    {
       "id":135,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What destination address is an ARP reply sent to?",
       "choice_a":"The IP address that sourced the ARP request",
       "choice_b":"255.255.255.255",
       "choice_c":"FFFF.FFFF.FFFF",
       "choice_d":"The MAC address that sourced the ARP request",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"ARP replies are unicast-that is, they're sent to the MAC address that sourced the request. ARP doesn't use IP."
    },
    {
       "id":136,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What's the default ARP entry timeout on Cisco routers and switches?",
       "choice_a":"5 minutes",
       "choice_b":"1 hour",
       "choice_c":"4 hours",
       "choice_d":"6 hours",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The default timeout is 4 hours, and you can modify it on a per-interface basis."
    },
    {
       "id":137,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What's the purpose of TCP connection establishment?",
       "choice_a":"Error control",
       "choice_b":"Synchronization of sequence numbers",
       "choice_c":"Reservation of bandwidth",
       "choice_d":"Synchronization of polling intervals",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The purpose of TCP connection establishment is to synchronize sequence numbers."
    },
    {
       "id":138,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the IP protocol number for TCP?",
       "choice_a":1,
       "choice_b":6,
       "choice_c":17,
       "choice_d":89,
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The IP protocol number for TCP is 6. The protocol number for ICMP is 1. For UDP, it's 17. For OSPF, it's 89."
    },
    {
       "id":139,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following can reduce the size of a broadcast domain? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Prune VLANs</li><li> Use 802.1Q trunks</li><li> Use routed instead of switched interfaces</li><li> Tag the native VLAN</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"You can reduce the size of a broadcast domain in two ways. First, if you're running a trunk between switches, you can prune a VLAN from the trunk to prevent traffic for that VLAN from traversing the trunk. Second, instead of running a trunk between switches, you can use routed links."
    },
    {
       "id":140,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You have three switches connected to VLAN 50. They're all running Spanning Tree and have the following base MAC addresses: <br>SW1 0010.84b0.ee30<br>SW2 007c.5d8a.e100<br>SW3 0084.8ede.fdd0<br>Which of the following will be the root for VLAN 50?",
       "choice_a":"SW1",
       "choice_b":"SW2",
       "choice_c":"SW3",
       "choice_d":"None of these",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"SW1 has the lowest base MAC address, so it will be the root."
    },
    {
       "id":141,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You have three switches connected to VLAN 10. They have the following base MAC addresses and are set to the default priority: <br>SW1 0010.84b0.ee30<br>SW2 007c.5d8a.e100<br>SW3 0084.8ede.fdd0<br>You plan to add another switch, SW4, to the topology but don't want it to become root. SW4 has a base MAC address of 000c.0f43.01a3. How can you accomplish this?",
       "choice_a":"Set SW4's bridge priority to 0",
       "choice_b":"Set SW4's bridge priority to 32768",
       "choice_c":"Set SW4's bridge priority to 61440",
       "choice_d":"Connect SW4 without making any other changes",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Setting the priority to 61440 would make it the highest priority, and thus the least preferred; 0 would make it best; 32768 would make it even, and it's the default. Just plugging SW4 in would make it root since it has the lowest burned-in address."
    },
    {
       "id":142,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"When you enable Spanning Tree on a switch, what does it advertise as the root bridge?",
       "choice_a":"The 0000.0000.0000 address",
       "choice_b":"The highest root bridge ID it receives",
       "choice_c":"The first root ID it receives",
       "choice_d":"Its own bridge ID",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"When a switch initially joins a topology, it advertises its own bridge ID as the root."
    },
    {
       "id":143,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"How does a switch calculate the lowest cost to the root bridge?",
       "choice_a":"Adding its own bridge priority to the bridge priority it receives in a BPDU",
       "choice_b":"Adding its own interface cost to the cost it receives in a BPDU",
       "choice_c":"Adding its own port priority to the port priority it receives in a BPDU",
       "choice_d":"Using the path via the bridge with the lowest bridge ID",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"To determine the cost to the root, a switch looks at the interface cost listed in the BPDU it receives and adds its own port cost. Only if it has multiple equal-cost paths does it consider port priority or bridge priority. A switch never adds its own bridge priority or port priority to that which it receives in a BPDU."
    },
    {
       "id":144,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You have a switch running IOS 12.4. Which global configuration command will ensure Rapid Spanning Tree is enabled for VLAN 1?",
       "choice_a":"<code>spanning-tree rapid-pvst</code>",
       "choice_b":"<code>spanning-tree mode pvst</code>",
       "choice_c":"<code>spanning-tree mode rapid-pvst</code>",
       "choice_d":"<code>spanning-tree vlan 1 mode rapid-pvst</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The command to enable RPVST+ is <code>spanning-tree mode rapid-pvst</code>. The Spanning Tree mode is enabled per switch, not per VLAN."
    },
    {
       "id":145,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"How frequently does a switch running Rapid Spanning Tree send configuration BPDUs?",
       "choice_a":"Every 1 second",
       "choice_b":"Every 2 seconds",
       "choice_c":"Every 5 seconds",
       "choice_d":"Every 15 seconds",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Every 2 seconds, a switch sends a configuration/Hello bridge protocol data unit (BPDU) out of every nonblocking port."
    },
    {
       "id":146,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What's the difference between the transmitting bridge ID and the root bridge ID? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> The transmitting bridge ID contains information about the switch that sent the BPDU.</li><li> The transmitting bridge ID doesn't contain any information about the root.</li><li> The root bridge ID contains the base MAC address of the root bridge.</li><li> The root bridge ID contains a MAC address based on one of the root bridge's interfaces.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The transmitting bridge ID simply identifies the switch that sent the BPDU. The root bridge ID contains the base MAC address of the root bridge. Because each switch initially assumes it's the root, the transmitting bridge ID and root bridge ID can refer to the same switch. The base MAC address isn't based on an interface MAC."
    },
    {
       "id":147,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You have three connected switches with the following bridge priorities: <br>SW1: 32788<br>SW2: 32770<br>SW3: 36885<br>There are no other switches in this topology. Which of the following can you conclude from this information? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> SW2 is the root for VLAN 20.</li><li> SW1 is the root for VLAN 20.</li><li> SW2 is in VLAN 2.</li><li> SW3 will never be the root.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Bridge priorities must be <italic>configured</italic> in increments of 4,096. The reason is that the VLAN ID is appended onto the configured priority. Hence, you can calculate that SW1 has a configured priority of 32768 and is in VLAN 20. SW3 has a configured priority of 36864 and is also in VLAN 20. SW1, having the lowest priority, is root. SW2 has a bridge priority of 32770, so it must have a configured priority of 32768 and be in VLAN 2."
    },
    {
       "id":148,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Consider the following two switches: SW1 has a base MAC address of 0000.1234.ABC9 with a bridge priority of 0. SW2 has a base MAC of 0000.1234.ABCA with a priority of 0. If both switches are placed in the same VLAN, which will become the Spanning Tree root?",
       "choice_a":"SW1",
       "choice_b":"SW2",
       "choice_c":"Neither",
       "choice_d":"Both",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"SW1 will become the root since its priority is the same as SW2 and it has the lower base MAC address."
    },
    {
       "id":149,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Switch SW1 is running RPVST+ on VLAN 1 and is the root. It's connected to SW2, which has VLAN 1 mapped to the <code>MST1</code> instance. You want to add VLAN 2 to both switches and make SW2 the root for VLAN 2 without impacting VLAN 1. How can you accomplish this?",
       "choice_a":"Make SW2 the root for <code>MST0</code>",
       "choice_b":"Map VLAN 2 to <code>MST1</code>",
       "choice_c":"Map VLAN 2 to <code>MST0</code>",
       "choice_d":"Make SW1 the root for <code>MST1</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"All VLANs map to <code>MST0</code> by default, so VLAN 2 would be included. Hence, all that's needed is to make SW2 the root for <code>MST0</code>. Mapping VLAN 2 to <code>MST1</code> would preclude making SW2 the root, since it's also mapped to VLAN 1, for which SW1 is already the root. Making SW1 the root for <code>MST1</code> would cause SW1 to become the root for VLAN 1."
    },
    {
       "id":150,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following must be the same on all switches in order for them to be in the same MST region? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Trunk encapsulation</li><li> Region name</li><li> Allowed VLANs</li><li> VLAN-to-instance mappings</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Region name, revision number, and a list of VLAN-to-instance mappings must be the same on all switches."
    },
    {
       "id":151,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following MST configuration commands will map VLANs 100, 400, and 900 to <code>MST3</code>?",
       "choice_a":"<code>instance 100,400,900 vlan 3</code>",
       "choice_b":"<code>instance 3 vlan 100,400,900</code>",
       "choice_c":"<code>spanning-tree mst 1 vlan 100,400,900</code>",
       "choice_d":"<code>vlan 100,400,900 instance 3</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The MST configuration command used to map VLANs 100, 400, and 900 to <code>MST3</code> is <code>instance 3 vlan 100,400,900. </code>"
    },
    {
       "id":152,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You attempted to configure MST to map VLAN 2 to <code>MST2</code>. However, running <code>show spanning-tree mst 2</code> gives the error <code>No mst information available for instance(s) 3</code>. What are two possible explanations?<ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> You used the wrong show command. Try <code>show spanning-tree vlan 2</code> instead.</li><li> VLAN 2 isn't configured on the switch.</li><li> You failed to type <code>exit</code> in MST configuration mode to save your changes.</li><li> You failed to issue a <code>write memory</code> command after making the changes.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"When you map only one VLAN to an instance, that VLAN must exist in the switch's local VLAN database. In order to save your changes, you must type <code>exit</code> in MST configuration mode. There's no need to save the running configuration, although it's a good idea. The <code>show</code> command given in the question is correct."
    },
    {
       "id":153,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"SW1 is running MST and has VLANs 2 through 10 mapped to <code>MST10</code>. SW1 is connected to SW2, which is running RPVST+. There are no physical loops in the topology. All of SW1's ports are forwarding in all VLANs. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> SW1 is the root for VLAN 1.</li><li> SW1 is the root for VLAN 2.</li><li> SW2 is the root for VLAN 1.</li><li> SW2 is the root for VLAN 2.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"When a switch running MST is connected to a switch running RPVST+, the MST simulates PVST with the connected switch. The MST switch advertises itself as the root for all VLANs. If the other switch advertises itself as the root, the MST switch will block its ports to that switch, placing them in a PVST Simulation Inconsistent state. Since SW1's ports are forwarding in all VLANs, it's clear that SW1 is the root for all VLANs."
    },
    {
       "id":154,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You want to ensure that a switch always remains root. Which of the following Spanning Tree extensions should you configure?",
       "choice_a":"BPDU Guard",
       "choice_b":"BPDU Filter",
       "choice_c":"Root Filter",
       "choice_d":"Root Guard",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Root Guard prevents another switch from becoming root. Use the interface command <code>spanning-tree guard root</code> on any ports that you do not want to become root ports."
    },
    {
       "id":155,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following Spanning Tree extensions can prevent loops caused by a user plugging a hub into a network jack in their cubicle?",
       "choice_a":"Loop Guard",
       "choice_b":"BPDU Filter",
       "choice_c":"BPDU Guard",
       "choice_d":"Root Guard",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"BPDU Guard error-disables a port if it receives a BPDU. BPDU Filter prevents a switch from sending or processing received BPDUs. Loop Guard places a port into a loop-inconsistent state if it fails to receive BPDUs. Root Guard prevents another switch from becoming root."
    },
    {
       "id":156,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What command provides the simplest way to enable BPDU Guard on all interfaces that are connected to user workstations?",
       "choice_a":"The global configuration command <code>errdisable recovery cause bpduguard</code>",
       "choice_b":"The global configuration command <code>spanning-tree bpduguard enable</code>",
       "choice_c":"The interface command <code>spanning-tree bpduguard enable</code>",
       "choice_d":"The global configuration command <code>spanning-tree portfast edge bpduguard default</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"You can issue the global command <code>spanning-tree portfast edge bpduguard default</code> to automatically enable BPDU Guard for any interface that has PortFast enabled, which you should do on all interfaces connected to end-user devices."
    },
    {
       "id":157,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You want to configure UDLD on a pair of switches connected by fiber-optic cable. In the event of a unidirectional link, you want to ensure that no switches block any ports. Which UDLD mode should you configure, and which command should you use? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>udld port </li><li>udld port aggressive</li><li> Normal mode</li><li> Aggressive mode</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"A, C",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"In normal mode, UDLD will only detect a unidirectional link but won't disable the port. To enable normal mode, use the interface command <code>udld port</code>."
    },
    {
       "id":158,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which are true regarding UDLD and Loop Guard? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Loop Guard disables ports on a per-VLAN basis.</li><li> Loop Guard can be configured to take no action in response to a loop.</li><li> UDLD can be configured to take no action in response to a loop.</li><li> UDLD can stop all traffic on an interface.</li></ol>",
       "choice_a":"A, B, C",
       "choice_b":"B, C, D",
       "choice_c":"A, C, D",
       "choice_d":"A, B, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Loop Guard places a port in an error-disabled state on a per-VLAN basis if it doesn't receive BPDUs for that VLAN. UDLD can be configured to detect a loop and then either take no action or disable the interface, stopping all traffic on it."
    },
    {
       "id":159,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You need to configure an 802.1Q trunk between two switches, SW1 and SW2. Which of the following interface commands, if configured on each switch, will result in a working 802.1Q trunk? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>switchport mode trunk on</li><li> switchport trunk encapsulation dot1q</li><li>switchport mode dynamic auto</li><li>switchport mode dynamic desirable</li><li>switchport trunk encapsulation negotiate</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, D",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"D, E",
       "correct_answer":"B",
       "explanation":"<code>switchport mode dynamic desirable</code> if configured on both ends will result in a trunk. Specifying the encapsulation type as <code>dot1q</code> using the command <code>switchport trunk encapsulation dot1q</code> will ensure that it's an 802.1Q trunk. Setting both sides to negotiate the encapsulation will result in an ISL trunk. Auto/auto won't form a trunk, since neither side will attempt to initiate negotiation. The command to create an unconditional trunk is <code>switchport mode trunk</code>."
    },
    {
       "id":160,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You've inherited a large network with several hundred switches. You're not using VLAN 1, but it's active on all trunks as the native VLAN. How can you remove it from all trunks? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Enable native VLAN tagging</li><li> Disable native VLAN tagging</li><li> Remove VLAN 1 from all switches</li><li> Prune VLAN 1 from all trunks</li><li> Shut down VLAN 1 on all switches</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"D, E",
       "correct_answer":"D",
       "explanation":"Enabling native VLAN tagging will allow you to prune VLAN 1 from all trunks. You can't remove VLAN 1 or shut it down."
    },
    {
       "id":161,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"On Switch A, you issue the <code>channel-group 7 mode on</code> command on a range of interfaces. Which command, if configured on the facing switch's links, will result in a working EtherChannel?",
       "choice_a":"<code>channel-group 7 mode active</code>",
       "choice_b":"<code>channel-group 1 mode on</code>",
       "choice_c":"<code>channel-group 7 mode desirable</code>",
       "choice_d":"<code>port-group 7 mode on</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The command configured on Switch A creates a static port channel. Hence, in order to get a working EtherChannel link, the other side must also be configured to create a static port channel. The channel group numbers don't have to match on both ends."
    },
    {
       "id":162,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You've configured a pair of links to use LACP Active mode. Configuring which of the following configuration commands on the facing switch will form an EtherChannel?",
       "choice_a":"<code>channel-group 2 mode passive</code>",
       "choice_b":"<code>channel-group 3 mode on</code>",
       "choice_c":"<code>channel-group 4 mode auto</code>",
       "choice_d":"<code>channel-group 3 mode desirable</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"If one end is Active, the other end must be Active or Passive to form an EtherChannel."
    },
    {
       "id":163,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Up to how many active ports can you have in an EtherChannel?",
       "choice_a":1,
       "choice_b":4,
       "choice_c":8,
       "choice_d":16,
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"You can have up to eight active links in a port channel."
    },
    {
       "id":164,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"How many backup ports can you have in an EtherChannel?",
       "choice_a":1,
       "choice_b":4,
       "choice_c":8,
       "choice_d":16,
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"You can have up to eight backup ports in a port channel."
    },
    {
       "id":165,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following modes is PAgP compatible with?",
       "choice_a":"On",
       "choice_b":"Active",
       "choice_c":"Passive",
       "choice_d":"Auto",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Valid PAgP modes are Auto and Desirable."
    },
    {
       "id":166,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following can result in a VRRP router having a priority of 255?",
       "choice_a":"Preemption is enabled.",
       "choice_b":"The default priority is 255.",
       "choice_c":"It's the first router configured in the group.",
       "choice_d":"The router is the group's IP address owner.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"If a router's interface IP is the same as the VRRP group's virtual IP, then the router is the IP address owner and automatically takes on a priority of 255. The default priority is 100."
    },
    {
       "id":167,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What is the default priority for HSRP?",
       "choice_a":"0",
       "choice_b":"100",
       "choice_c":"254",
       "choice_d":"255",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The default priority for HSRP is 100. If the priority is equal on all routers in the group, the one with the highest IP address becomes the active router."
    },
    {
       "id":168,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which protocol uses the multicast address <code>224.0.0.2</code>?",
       "choice_a":"HSRP",
       "choice_b":"VRRP",
       "choice_c":"GLBP",
       "choice_d":"LACP",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"HSRP version 1 uses the \u0022all routers\u0022 multicast address <code>224.0.0.2. </code> HSRP uses <code>224.0.0.18. </code> GLBP and HSRP version 2 use <code>224.0.0.102</code>."
    },
    {
       "id":169,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What's the virtual MAC address format for VRRP?",
       "choice_a":"<code>0000.5e00.01xx</code>, with <code>xx</code> being the group number in hexadecimal",
       "choice_b":"<code>0000.5e00.01xx</code>, with <code>xx</code> being the group number in decimal",
       "choice_c":"<code>0007.B400.01xx</code>, with <code>xx</code> being the group number in hexadecimal",
       "choice_d":"<code>0007.0c07.acxx</code>, with <code>xx</code> being the forwarder number in hexadecimal",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The virtual MAC address format for VRRP is <code>0000.5e00.01xx</code>, with <code>xx</code> being the group number in hexadecimal."
    },
    {
       "id":170,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is true of GLBP? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> There can be multiple active AVGs at a time.</li><li> An AVG can be an AVF.</li><li> There can be multiple active AVFs at a time.</li><li> You configure the load-balancing method on each AVF.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"An AVG can be an AVF. GLBP achieves load balancing by having multiple AVFs active at a time. There can't be multiple AVGs active at a time. You configure the load-balancing method on the AVG."
    },
    {
       "id":171,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following modes is LACP compatible with? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Desirable</li><li> Passive</li><li> Auto</li><li> Active</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"LACP modes are Active and Passive."
    },
    {
       "id":172,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"How can you ensure that a router becomes a DR for a specific subnet?",
       "choice_a":"Set the OSPF interface priority to 0",
       "choice_b":"Enable OSPF on the router before enabling it on any other routers",
       "choice_c":"Configure the OSPF RID to be the highest in the subnet",
       "choice_d":"Set the OSPF interface priority to 255",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"During a DR election, the router with the highest interface priority will be elected."
    },
    {
       "id":173,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which command will ensure a router never becomes a DR or a BDR?",
       "choice_a":"<code>ip ospf dr disable</code>",
       "choice_b":"<code>ip ospf priority 255</code>",
       "choice_c":"<code>ip ospf priority 0</code>",
       "choice_d":"<code>router-id 0.0.0.0</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Setting the interface priority to 0 will prevent a router from becoming a DR or BDR on that segment."
    },
    {
       "id":174,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What's the administrative distance of OSPF inter-area routes?",
       "choice_a":20,
       "choice_b":90,
       "choice_c":110,
       "choice_d":120,
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"All OSPF routes have a default AD of 110."
    },
    {
       "id":175,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What IP address and protocol number does OSPF use to send Hello packets?",
       "choice_a":"<code>224.0.0.10</code> over IP protocol 89",
       "choice_b":"<code>224.0.0.6</code> over IP protocol 89",
       "choice_c":"<code>224.0.0.5</code> over IP protocol 88",
       "choice_d":"<code>224.0.0.5</code> over IP protocol 89",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"OSPF uses <code>224.0.0.5</code> over IP protocol 89 to send Hello packets."
    },
    {
       "id":176,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following must match for OSPF routers to form an adjacency?",
       "choice_a":"OSPF process number",
       "choice_b":"MTU",
       "choice_c":"<code>network</code> statement",
       "choice_d":"Router IDs",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The MTU must match. The <code>network</code> statements and OSPF process numbers don't have to, but they can. Router IDs must not match on different OSPF routers."
    },
    {
       "id":177,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What LSA type is advertised to all normal areas?",
       "choice_a":"Type 5 External",
       "choice_b":"Type 3 Summary",
       "choice_c":"Type 1 Router",
       "choice_d":"Type 2 Network",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The type 5 External LSA is advertised to all normal areas. The others remain within an area."
    },
    {
       "id":178,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"An OSPF router has one interface in Area 51 and no interfaces in any other areas. Which of the following areas can it not have another interface in?",
       "choice_a":"Area 0.0.0.0",
       "choice_b":"Area 1",
       "choice_c":"Area 51",
       "choice_d":"Area 0",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The router can have another interface in Area 0 (also known as Area 0.0.0.0), making it an ABR. It can also have another interface in Area 51. But it can't have an interface in another nonzero area unless it's bordering Area 0."
    },
    {
       "id":179,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following LSAs reduces flooding in a broadcast domain?",
       "choice_a":"Type 5 External LSA",
       "choice_b":"Type 3 Summary LSA",
       "choice_c":"Type 1 Router LSA",
       "choice_d":"Type 2 Network LSA",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"On a broadcast segment, one router is elected as the DR. Only the DR receives type 1 LSAs from other OSPF routers on the segment and uses these to generate and send a type 2 Network LSA that describes all the routers on the segment."
    },
    {
       "id":180,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following suggests the absence of a type 2 Network LSA?",
       "choice_a":"Backup designated router",
       "choice_b":"Transit network type",
       "choice_c":"Broadcast network type",
       "choice_d":"Point-to-point network type",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Type 2 Network LSAs are generated by a designated router. DRs only exist on broadcast or transit network types, but not point-to-point network types. The presence of a backup designated router implies the presence of a designated router."
    },
    {
       "id":181,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following is true of a type 3 Summary LSA?",
       "choice_a":"It advertises an IP network summary into an area.",
       "choice_b":"It summarizes the information in type 1 LSAs from one area.",
       "choice_c":"It summarizes the information in type 2 LSAs from multiple areas.",
       "choice_d":"It is generated by an ASBR.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"A type 3 Summary LSA is generated by an ABR and summarizes the information in type 1 and type 2 LSAs from one area. It doesn't necessarily include an IP network summary."
    },
    {
       "id":182,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"An OSPF router bordering areas 0 and 1 redistributes EIGRP routes into OSPF. Which two of the following describe this router? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> ASBR</li><li> DR</li><li> BDR</li><li> ABR</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"A, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"An OSPF router bordering two areas is an ABR, whereas one that redistributes routes into OSPF is an ASBR. A single router can be both."
    },
    {
       "id":183,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"OSPF router R1 has a single interface with the IP address <code>1.0.0.1/24</code>. It has two full adjacencies: one with a DR with a RID of <code>1.0.0.2</code> and another with a BDR with a RID of <code>1.0.0.3</code>. Which of the following values can you configure for the OSPF RID on R1?",
       "choice_a":"<code>1.0.0.2</code>",
       "choice_b":"<code>2.0.0.1</code>",
       "choice_c":"<code>1</code>",
       "choice_d":"<code>0.0.0.0</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"No two OSPF routers in a topology should have the same RID. A RID must be between <code>0.0.0.1</code> and <code>255.255.255.255</code>."
    },
    {
       "id":184,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of following must match for two routers to form a full OSPF adjacency?",
       "choice_a":"Network type",
       "choice_b":"Subnet",
       "choice_c":"Area number",
       "choice_d":"RID",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The area number is the only thing that must match. The subnet type doesn't have to match on a point-to-point interface. The network types don't have to match to form an adjacency, only to exchange routes. Each router must have a unique RID."
    },
    {
       "id":185,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Router R1 has interfaces in Area 0, Area 7, and Area 12. Router R2 is connected to Area 7, and router R3 is connected to Area 12. The routers have no other connected interfaces. Which of the following is true of this topology?",
       "choice_a":"R2 and R3 can't have interfaces in the same area.",
       "choice_b":"R2 and R3 can connect via Area 0.",
       "choice_c":"R2 and R3 can connect via a nonzero area.",
       "choice_d":"R1 can't have another interface in Area 7 or Area 12.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"It's a good idea to sketch a diagram of this topology, as shown. R2 and R3 can't have interfaces in the same area for two reasons. First, R2 and R3 can't be connected via Area 0 because R1 already has an interface in Area 0, and doing so would split Area 0, which isn't allowed. R2 and R3 can't be connected via a nonzero area because nonzero areas must be connected to Area 0. It's perfectly allowable for R1 to have another interface in Area 7 or Area 12, since it's an ABR. <img src='/question_assets/ccnp/5_image1.png'></img>"
    },
    {
       "id":186,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Assuming everything is properly configured for a broadcast network, which state do OSPF neighbors stay in if neither is a DR or a BDR?",
       "choice_a":"Init",
       "choice_b":"Full",
       "choice_c":"Two-way",
       "choice_d":"Exstart",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"In a broadcast network, non-(B)DR neighbors remain in the two-way state."
    },
    {
       "id":187,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"In which OSPF state do routers first exchange full link-state information?",
       "choice_a":"Two-way",
       "choice_b":"Full",
       "choice_c":"Exchange",
       "choice_d":"Loading",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Routers initially exchange full link-state information in the Loading stage. In the Exchange stage, they only exchange LSA headers."
    },
    {
       "id":188,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What hashing algorithm does OSPF cryptographic authentication use?",
       "choice_a":"MD5",
       "choice_b":"SHA1",
       "choice_c":"SHA256",
       "choice_d":"CRC32",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"OSPF cryptographic authentication uses the MD5 hashing algorithm."
    },
    {
       "id":189,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following OSPF router commands enables MD5 authentication for all router interfaces in Area 2?",
       "choice_a":"<code>area 2 authentication</code>",
       "choice_b":"<code>ip ospf authentication message-digest</code>",
       "choice_c":"<code>area 2 authentication message-digest</code>",
       "choice_d":"<code>ip ospf message-digest-key 1 md5 mypassword</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The command <code>area 2 authentication message-digest</code> enables MD5 authentication for all interfaces in Area 2. Failing to specify the <code>message-digest</code> keyword will enable clear-text authentication."
    },
    {
       "id":190,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following is <italic>not</italic> a valid OSPF authentication type?",
       "choice_a":"Null",
       "choice_b":"Secret",
       "choice_c":"Clear text",
       "choice_d":"Message digest",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"There isn't a \u0022secret\u0022 authentication type."
    },
    {
       "id":191,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which two commands make <code>Gi0/3</code> an OSPF passive interface?<ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>router ospf 1</li><li> interface gi0/3</li><li>passive-interface gi0/3</li><li>ip ospf passive-interface</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Passive interfaces are configured under the OSPF router configuration, not the interface configuration."
    },
    {
       "id":192,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What multicast address does EIGRP use for Hello packets?",
       "choice_a":"<code>255.255.255.255</code>",
       "choice_b":"<code>224.0.0.5</code>",
       "choice_c":"<code>224.0.0.10</code>",
       "choice_d":"<code>224.0.0.9</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"EIGRP sends Hello packets to <code>224.0.0.10</code>."
    },
    {
       "id":193,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What IP protocol does EIGRP use?",
       "choice_a":87,
       "choice_b":88,
       "choice_c":89,
       "choice_d":1,
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"EIGRP uses IP protocol 88."
    },
    {
       "id":194,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the default AD of an external EIGRP route?",
       "choice_a":20,
       "choice_b":90,
       "choice_c":110,
       "choice_d":170,
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The default AD for an external EIGRP route is 170."
    },
    {
       "id":195,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the default AD of an internal EIGRP route?",
       "choice_a":20,
       "choice_b":90,
       "choice_c":110,
       "choice_d":200,
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The default AD of an internal EIGRP route is 90."
    },
    {
       "id":196,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is CEF per-destination load sharing based on?",
       "choice_a":"Source port-destination port pair",
       "choice_b":"Source IP-destination IP pair",
       "choice_c":"Destination IP",
       "choice_d":"Source IP",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The default CEF load-sharing algorithm is based on a hash of the source and destination IP addresses."
    },
    {
       "id":197,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"The <code>show eigrp topology</code> command shows the following two possible next hops for the 10.0.36.0/29 prefix: <br> <code>via 10.0.56.6 (5632/2816), GigabitEthernet0/0</code> <br> <code>via 10.0.45.4 (3328/3072), GigabitEthernet0/3</code> <br>Assuming a variance of 1, which of the following is true?",
       "choice_a":"<code>10.0.45.4</code> and <code>10.0.56.6</code> are both successors.",
       "choice_b":"<code>10.0.56.6</code> is a successor.",
       "choice_c":"<code>10.0.45.4</code> is a feasible successor.",
       "choice_d":"<code>10.0.56.6</code> is a feasible successor.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"A variance of 1 means that EIGRP will perform only equal-cost multipathing. <code>10.0.45.4</code> is the successor because it has the lowest feasible distance. <code>10.0.56.6</code> is a feasible successor because its advertised distance is less than <code>10.0.45.4</code>'s feasible distance."
    },
    {
       "id":198,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the primary purpose of EIGRP's feasibility condition?",
       "choice_a":"Rapid convergence",
       "choice_b":"Shortest path selection",
       "choice_c":"Loop prevention",
       "choice_d":"Route filtering",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The feasibility condition precludes the possibility of feasible successors that may create a routing loop. The purpose of using feasible successors is to enable rapid convergence. The DUAL algorithm attempts to find the shortest loop-free path. The feasibility condition has nothing to do with route filtering."
    },
    {
       "id":199,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"When a successor route goes down and there is no feasible successor, which of the following things occur? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> The route becomes SIA.</li><li> The router advertises the route with an infinite metric.</li><li> The route becomes active.</li><li> The router sends a query to its neighbors.</li><li> The active timer stops.</li></ol>",
       "choice_a":"A, B, C",
       "choice_b":"B, C, D",
       "choice_c":"C, D, E",
       "choice_d":"A, C, D",
       "choice_e":"A, D, E",
       "correct_answer":"B",
       "explanation":"When there's no feasible successor, the router places the route in the active state, starts the active timer, advertises the route with an infinite metric, and sends queries to its neighbors. The route isn't stuck in active until the active timer expires."
    },
    {
       "id":200,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What happens when a router's EIGRP active timer for a neighbor expires?",
       "choice_a":"The adjacency with the neighbor is reset.",
       "choice_b":"The active route is removed from the IP routing table.",
       "choice_c":"The router sends an update to the neighbor.",
       "choice_d":"The router sends a query to the neighbor.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"When the active timer expires, the router resets its adjacency with its neighbor. The other steps occur prior to the active timer expiring."
    },
    {
       "id":201,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following EIGRP K values are associated with bandwidth in the weighted metric formula? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> K1</li><li> K2</li><li> K3</li><li> K4</li><li> K5</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, E",
       "correct_answer":"A",
       "explanation":"K1 and K2 are associated with bandwidth. Keep in mind that the default values are K1 = 1 and K2 = 0."
    },
    {
       "id":202,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following EIGRP K values is associated with delay in the weighted metric formula?",
       "choice_a":"K1",
       "choice_b":"K2",
       "choice_c":"K3",
       "choice_d":"K4",
       "choice_e":"K5",
       "correct_answer":"C",
       "explanation":"K3 is associated with delay, and its default value is 1."
    },
    {
       "id":203,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Assuming the default K values, what is the EIGRP weighted metric formula?",
       "choice_a":"256 ´ (bandwidth ´ delay)",
       "choice_b":"256 ´ (bandwidth + delay)",
       "choice_c":"256 + (bandwidth + delay)",
       "choice_d":"256 ´ (bandwidth + reliability)",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Assuming the default K values of K1 = 1, K2 = 0, K3 = 1, K4 = 0, and K5 = 0, the weighted metric formula can be boiled down to 256 ´ (bandwidth + delay)."
    },
    {
       "id":204,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following EIGRP output: <br> <code>P 203.0.113.0/30, 1 successors, FD is 26368, tag is 65550</code> <br> <code>via 10.0.56.5 (26368/26112), GigabitEthernet0/0</code> <br> <code>via 10.0.36.3 (282112/26112), GigabitEthernet0/2</code> <br>How can you enable unequal cost multipathing?",
       "choice_a":"Increase the maximum paths to 2",
       "choice_b":"Disable CEF",
       "choice_c":"Adjust the metrics to make both routes equal",
       "choice_d":"Set the variance multiplier to 11",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The ratio of the routes is about 10.7, so increasing the variance multiplier to 11 will enable unequal cost multipathing. The default maximum paths is 4, so there's no need to change it to 2. Making both routes equal will enable equal cost multipathing. Disabling CEF won't make any difference."
    },
    {
       "id":205,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the default SIA timer?",
       "choice_a":"10 seconds",
       "choice_b":"30 seconds",
       "choice_c":"3 minutes",
       "choice_d":"5 minutes",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The default SIA timer is 3 minutes."
    },
    {
       "id":206,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What value does EIGRP use for bandwidth in the weighted metric formula?",
       "choice_a":"Constrained bandwidth",
       "choice_b":"Constrained bandwidth ¸ 256 – load",
       "choice_c":"107 ¸ cumulative bandwidth",
       "choice_d":"107 ¸ constrained bandwidth",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"EIGRP inverts the actual constrained bandwidth so that the higher the bandwidth, the smaller the metric."
    },
    {
       "id":207,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"EIGRP routers R1 and R2 have an adjacency over a 1 Gbps link, whereas routers R2 and R3 have an adjacency over a 10 Gbps link. For the path traversing R1, R2, and R3, what is the constrained bandwidth?",
       "choice_a":"10,000,000 kbps",
       "choice_b":"1 Gbps",
       "choice_c":"10 Gbps",
       "choice_d":"11 Gbps",
       "choice_e":"9 Gbps",
       "correct_answer":"B",
       "explanation":"The constrained bandwidth is the minimum bandwidth along a path, so it would be 1 Gbps"
    },
    {
       "id":208,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"EIGRP routers R1 and R2 have an adjacency over a link with a 100 µsec delay, whereas routers R2 and R3 have an adjacency over a link with a 30µsec delay. For the path traversing R1, R2, and R3, what is delay value EIGRP considers in calculating a metric?",
       "choice_a":"30 µsec",
       "choice_b":"70 µsec",
       "choice_c":"100 µsec",
       "choice_d":"130 µsec",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"EIGRP uses the cumulative delay along a path, which would be 130 µsec."
    },
    {
       "id":209,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"A router has two EIGRP paths: one via R1 with a distance of 3,328 and another via R2 with a distance of 5,632. Using unequal cost multipathing, approximately what percentage of traffic will go through R1?",
       "choice_a":"26%",
       "choice_b":"37%",
       "choice_c":"50%",
       "choice_d":"64%",
       "choice_e":"71%",
       "correct_answer":"B",
       "explanation":"The traffic share count is based on the ratio of the distances. To calculate this manually, add the distances for R1 and R2 (3,328 + 5,632 = 8,960). Then divide R1’s distance by the total to get the traffic share percentage (3,328 ¸ 8,960 » .37)."
    },
    {
       "id":210,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following is <italic>not</italic> included in the EIGRP weighted metric formula?",
       "choice_a":"Load",
       "choice_b":"Delay",
       "choice_c":"Reliability",
       "choice_d":"MTU",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"MTU isn't used in metric calculations, even though it is advertised in route updates."
    },
    {
       "id":211,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following can cause a route to get stuck in active?",
       "choice_a":"MTU mismatch",
       "choice_b":"Redistribution",
       "choice_c":"A cut fiber",
       "choice_d":"A routing loop",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"A cut fiber can lead to packet loss, which can result in a route getting SIA. A routing loop wouldn't cause SIA because EIGRP neighbors communicate using a link-local multicast address. An MTU mismatch may cause an adjacency not to form but wouldn't cause SIA."
    },
    {
       "id":212,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What type of protocol best describes BGP?",
       "choice_a":"Hybrid",
       "choice_b":"Distance vector",
       "choice_c":"Path vector",
       "choice_d":"Link state",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"BGP is a path vector protocol that uses the AS path count rather than the hop count in calculating the best path to a prefix."
    },
    {
       "id":213,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following does BGP consider first to determine the best path?",
       "choice_a":"Oldest route",
       "choice_b":"AS path length",
       "choice_c":"Origin of the route",
       "choice_d":"Remote preference",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"On Cisco routers, BGP uses weight and local preference, followed by AS path, in that order."
    },
    {
       "id":214,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following is true of BGP?",
       "choice_a":"It identifies an AS using a 4-byte process number.",
       "choice_b":"It converges faster than OSPF.",
       "choice_c":"It periodically sends route updates.",
       "choice_d":"It can consider IGP metrics in best path decisions.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"BGP can consider IGP metrics in best path decisions."
    },
    {
       "id":215,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following BGP AS numbers can be used on the public Internet?",
       "choice_a":777,
       "choice_b":64555,
       "choice_c":65535,
       "choice_d":65536,
       "choice_e":101101,
       "correct_answer":"A",
       "explanation":"AS numbers that can be used on the Internet range from 1 to 64,495 and from 131,072 to 4,199,999,999."
    },
    {
       "id":216,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"An eBGP router in AS 67677 receives a route for the <code>192.0.9.0/24</code> prefix that has AS 67677 already in the path. Which of the following will it do?",
       "choice_a":"Discard all routes with the <code>192.0.9.0/24</code> prefix",
       "choice_b":"Remove the AS number and advertise the route",
       "choice_c":"Discard only the received route",
       "choice_d":"Advertise the received route as is",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"BGP uses the AS path for loop prevention. Upon receiving a route with its own AS in the AS path, an eBGP router will discard the route, meaning it won't install it in its BGP RIB or IP routing table, nor will it advertise the route."
    },
    {
       "id":217,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"How do BGP neighbors communicate?",
       "choice_a":"TCP port 179",
       "choice_b":"TCP port 8179",
       "choice_c":"IP protocol 179",
       "choice_d":"IP protocol 88",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"BGP peers use TCP port 179."
    },
    {
       "id":218,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"How frequently do BGP peers send keepalive messages?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"80 seconds",
       "choice_d":"180 seconds",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"BGP peers send keepalive messages every 60 seconds."
    },
    {
       "id":219,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the default BGP hold timer?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"80 seconds",
       "choice_d":"180 seconds",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The default BGP hold timer is 180 seconds (3 minutes)."
    },
    {
       "id":220,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"In which of the following session states do BGP peers exchange routes?",
       "choice_a":"Open",
       "choice_b":"Open Confirm",
       "choice_c":"Active",
       "choice_d":"Established",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"In the Established state, BGP peers exchange routes. The Active state is when the active router-the one with the highest IP address-initiates a new TCP connection with its neighbor."
    },
    {
       "id":221,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following two configuration commands will configure a BGP router in AS 65001 to form a neighborship with BGP router <code>203.0.113.2</code> in AS 65550? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>router bgp 65550</li><li>router bgp 65001 </li><li>neighbor 203.0.113.2 remote-as 65550</li><li>neighbor 203.0.113.2 remote-as 65001 </li><li>neighbor 203.0.113.2 local-as 65001</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"D, E",
       "correct_answer":"B",
       "explanation":"You specify the AS of a router in the router configuration command. You specify the AS of the neighbor using the <code>remote-as</code> keyword."
    },
    {
       "id":222,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"You've configured routers R1 and R2 to form an eBGP session. Which of the following commands will conclusively tell you whether they have established a BGP session?",
       "choice_a":"<code>show ip route</code>",
       "choice_b":"<code>show bgp</code>",
       "choice_c":"<code>show ip bgp</code>",
       "choice_d":"<code>show ip bgp neighbors</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The command <code>show ip bgp neighbors</code> will give you details on the BGP session state. <code>show ip route</code> can show you installed routes, but it's possible that due to BGP's slow reconvergence times a BGP route may linger in the IP routing table even if the BGP session it came from is down. For the same reason, <code>show bgp</code> and <code>show ip bgp</code> are wrong, and neither includes information on the session state."
    },
    {
       "id":223,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Router R1 has the prefix <code>10.0.24.0/24</code> installed in its IP routing table as an OSPF-learned route. Which of the following BGP router configuration commands cause R1 to advertise the prefix <code>10.0.24.0/24</code> to its BGP peers?",
       "choice_a":"<code>network 10.0.24.0</code>",
       "choice_b":"<code>network 10.0.24.0 mask 0.0.0.255</code>",
       "choice_c":"<code>network 10.0.24.0 mask 255.255.255.0</code>",
       "choice_d":"<code>redistribute connected</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"To advertise <code>10.0.24.0/24</code>, you need to specify both the subnet and the subnet mask. If you don't specify the subnet mask, BGP will assume the classful mask (<code>255.0.0.0</code>). Redistributing connected routes won't work because the route is an OSPF-learned route."
    },
    {
       "id":224,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"A BGP router receives two routes with equal AS path length. What will the router analyze next to determine the best path?",
       "choice_a":"Weight",
       "choice_b":"Local preference",
       "choice_c":"Origin type",
       "choice_d":"MED",
       "choice_e":"Lowest AS number",
       "correct_answer":"C",
       "explanation":"The router would determine the best path by analyzing weight, local preference, and shortest AS path. Since the AS path length is equal, the next attribute it would consider would be the origin type."
    },
    {
       "id":225,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following BGP origin types is most preferred?",
       "choice_a":"Incomplete",
       "choice_b":"IGP",
       "choice_c":"EGP",
       "choice_d":"Oldest",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"IGP origin types are preferred over incomplete. EGP is a defunct origin type whose namesake is the defunct precursor to BGP-the Exterior Gateway Protocol. Oldest isn't an origin type."
    },
    {
       "id":226,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"R1 has the prefix <code>10.9.0.0/16</code> in its IP routing table, learned from EIGRP AS 50. There are no other BGP, IGP, or static routes in the routing table. You execute the following BGP router configuration commands on R1: <br> <code>network 10.9.0.0 mask 255.255.255.0</code> <br> <code>redistribute eigrp 50</code> <br> <code>redistribute connected</code> <br>Which of the following will be true regarding the route R1 advertises for the <code>10.9.0.0/16</code> prefix?",
       "choice_a":"<code>10.9.0.0/24</code> will have an incomplete origin    type.",
       "choice_b":"<code>10.9.0.0/16</code> will have an incomplete origin type.",
       "choice_c":"<code>10.9.0.0/16</code> will have an IGP origin type.",
       "choice_d":"<code>10.9.0.0/24</code> will have an IGP origin type.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"<code>10.9.0.0/24</code> doesn't exist in R1's routing table, so the <code>network</code> command will have no effect. Instead, the <code>redistribute eigrp 50</code> command will redistribute the <code>10.9.0.0/16</code> prefix into BGP with an incomplete origin type."
    },
    {
       "id":227,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following BGP attributes is not advertised outside of an AS?",
       "choice_a":"AS path",
       "choice_b":"Local preference",
       "choice_c":"MED",
       "choice_d":"Origin type",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Local preference is advertised only within an AS, between iBGP peers. AS path, MED, and origin type are advertised between eBGP peers."
    },
    {
       "id":228,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What are two possible outcomes of modifying the AS path attribute? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> The origin type changes</li><li> Creates a routing loop</li><li> Makes two routes equally preferred</li><li> Prefers one route over another</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Modifying the AS path can create a routing loop, and it can also be used to prefer one route over another. It will not make two routes equally preferred, since if the AS path length is equal between two routes, BGP will consider other attributes. Modifying the AS path for a route will not change the origin type."
    },
    {
       "id":229,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"A BGP router has a connected route to the prefix <code>12.7.3.0/24</code>. The prefix is being advertised via OSPF process 1. Which of the following BGP router configuration commands will advertise a route to this prefix with an IGP origin type?",
       "choice_a":"<code>redistribute connected</code>",
       "choice_b":"<code>redistribute ospf 1</code>",
       "choice_c":"<code>redistribute connected metric igp</code>",
       "choice_d":"<code>network 12.7.3.0 mask 255.255.255.0</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The <code>network</code> statement will advertise a prefix as an IGP origin type. Redistributing a prefix will always advertise it as an incomplete origin type."
    },
    {
       "id":230,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following commands will perform a soft BGP reconfiguration with neighbor 1.3.3.7?",
       "choice_a":"<code>neighbor 1.3.3.7 reset</code>",
       "choice_b":"<code>neighbor 1.3.3.7 shutdown</code>",
       "choice_c":"<code>clear ip bgp * soft</code>",
       "choice_d":"<code>clear bgp * soft</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"<code>clear ip bgp * soft</code> will cause BGP to perform a soft reconfiguration. Using the <code>network</code> command with the <code>shutdown</code> keyword will simply shut down the BGP session with 1.3.3.7. The other commands aren't valid."
    },
    {
       "id":231,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following prefix list and route map on router R1: <br> <code>ip prefix-list all-private: 3 entries</code> <br>   <code>seq 5 permit 10.0.0.0/8 le 32</code> <br> <code>seq 10 deny 0.0.0.0/0 le 32</code> <br> <code>route-map allow-public, deny, sequence 10</code> <br> <code>Match clauses: </code> <br> <code>ip address prefix-lists: all-private</code> <br> <code>Set clauses: </code> <br>  <code>Policy routing matches: 0 packets, 0 bytes</code> <br> <code>route-map R4, permit, sequence 20</code> <br>   <code>Match clauses: </code> <br> <code>Set clauses: </code> <br> <code>Policy routing matches: 0 packets, 0 bytes</code> <br> What is the effect of applying this route map to inbound routes from an eBGP neighbor?",
       "choice_a":"R1 won't install any BGP routes for the <code>10.0.0.0/16</code> prefix.",
       "choice_b":"R1 will install BGP routes for the <code>10.0.0.0/8</code> prefix.",
       "choice_c":"R1 won't advertise any BGP routes for the prefix <code>10.0.0.0/24</code>.",
       "choice_d":"R1 won't install any BGP routes.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"This is a complex configuration and might require some scratch paper. The prefix list matches any prefix with a subnet falling into the <code>10.0.0.0/8</code> range with a prefix length from 8 to 32. This includes <code>10.0.0.0/8</code> and <code>10.0.0.0/16</code>. The first sequence in the route map is a deny sequence that matches the IP prefix list. Hence, these prefixes will match the sequence and will be denied. When applied as an inbound route map, any incoming routes for <code>10.0.0.0/8</code> or <code>10.0.0.0/16</code> won't be installed in R1's IP routing table. The second sequence in the route map is a permit sequence that matches all other prefixes by default, so R1 may still install other routes learned from the neighbor <code>1.3.3.7</code>. Nothing in this configuration, however, will stop R1 from advertising these prefixes (for instance, if it learns them from elsewhere, such as another neighbor)."
    },
    {
       "id":232,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is a valid use of static NAT?",
       "choice_a":"Conserving IP addresses",
       "choice_b":"Hiding a source IP address",
       "choice_c":"Changing a source port number",
       "choice_d":"Hiding a source IP address",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Static NAT hides the inside local address by changing the inside source IP of a packet to an outside address before sending it out the outside interface. This is the antithesis of address conservation. Static NAT doesn't change any port numbers."
    },
    {
       "id":233,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"On your inside network you have a host with the IP address <code>10.1.1.1. </code> Its next-hop gateway is an Internet router with an IP of <code>10.1.1.254. </code> The Internet router's interface connected to the ISP router has the interface IP <code>192.0.2.2. </code> Which of the following are true of this configuration? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>10.1.1.1 is an inside local address.</li><li>192.0.2.2 is an outside local address.</li><li>192.0.2.2 is an inside global address.</li><li>10.1.1.1 is an inside global address.</li><li>10.1.1.254 is an inside global address.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, C",
       "correct_answer":"E",
       "explanation":"The address <code>10.1.1.1</code> is accessible from the inside network, making it an inside local address. <code>192.0.2.2</code> is a globally reachable address, but it's assigned to an interface on the Internet router on the inside network, so it's an inside global address."
    },
    {
       "id":234,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What happens when a router configured for dynamic NAT exhausts its NAT address pool?",
       "choice_a":"Traffic from inside hosts without a mapping will be dropped.",
       "choice_b":"The oldest translation will be deleted.",
       "choice_c":"The router will use PAT.",
       "choice_d":"All translations will be deleted.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"When the global address pool is exhausted, the NAT router will drop packets from subsequent hosts that send traffic to the outside network."
    },
    {
       "id":235,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"On a NAT router, which of the following can be an inside global address? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> A loopback interface address</li><li> An outside local address</li><li> An inside interface address</li><li> An outside interface address</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"A, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"An inside global address can be one assigned to an outside interface (an inside global address) or a loopback interface. Any interface marked as an inside interface can't be used as the source for an inside global address. An outside local address is a local address in an outside network, so it obviously couldn't be used as an inside global address."
    },
    {
       "id":236,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is true of the command <code>ip nat inside source list 1 pool globalpool</code>?",
       "choice_a":"Inside local source IP addresses matching ACL 1 will be translated.",
       "choice_b":"Inside local destination IP addresses matching ACL 1 will be translated.",
       "choice_c":"Inside local source IP addresses matching the pool <code>globalpool</code> will be translated.",
       "choice_d":"Outside global source IP addresses matching the pool <code>globalpool</code> will be translated.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Any inside local source IP addresses matching ACL 1 will be translated to one of the inside global addresses listed in the NAT pool named <code>globalpool</code>."
    },
    {
       "id":237,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"A few hours after enabling dynamic NAT on a router, some inside hosts are unable to access Internet resources. You enable NAT debugging on the router and then see the following message: <br> <code>NAT: translation failed (A), dropping packet s=7.0.0.99 d=10.0.12.1</code> <br>Which of the following steps is most likely to independently and permanently resolve the issue? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Clear the NAT translation table.</li><li> Increase the size of the NAT pool.</li><li> Use PAT instead of dynamic NAT.</li><li> Use static NAT instead of dynamic NAT.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"It appears that the NAT router is running out of inside global addresses in the NAT pool. Thus, increasing the size of the NAT pool will probably resolve the issue. Alternatively, using PAT instead of dynamic NAT will let all inside hosts share a single inside global IP address. Clearing the NAT translation table might provide only a temporary fix."
    },
    {
       "id":238,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"How does PAT conserve IP addresses?",
       "choice_a":"By overloading an inside global address",
       "choice_b":"By using a pool of inside global addresses",
       "choice_c":"By performing one-to-one translation between a local and global address",
       "choice_d":"By overloading port numbers",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"With PAT, multiple inside source addresses can be translated to the same inside global address-a process called NAT overloading."
    },
    {
       "id":239,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following commands individually configures PAT? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>ip nat pool natpool 2.0.0.1 2.0.0.3 netmask 255.255.255.248</li><li>ip nat inside source list 1 pool natpool overload</li><li>ip nat inside source list 1 pool natpool</li><li>ip nat inside source list 1 interface gi0/0 overload</code> </li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Port address translation-also known as NAT overload-translates multiple inside local source addresses to a single global address. The global address can come from an outside interface or from a pool."
    },
    {
       "id":240,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Consider the following NAT translation table output: <br> <code>Pro Inside global      Inside local       Outside local      Outside global</code> <br> <code>Pro Inside global      Inside local       Outside local      Outside global</code> <br> <code>icmp 2.0.0.2:16        7.0.0.12:16        10.0.12.1:16       10.0.12.1:16</code> <br> <code>--- 2.0.0.2            7.0.0.12           ---                -- </code> <br>Which of the following configurations could this indicate? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Static NAT</li><li> NAT overload</li><li> Outside static NAT</li><li> Dynamic NAT</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"A, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The output indicates a one-to-one mapping between an inside local and an inside global address, so it must be static or dynamic NAT."
    },
    {
       "id":241,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Consider the following NAT translation table output: <br> <code>Pro Inside global      Inside local       Outside local      Outside global</code> <br> <code>--- ---                ---                1.1.1.1            10.0.12.1</code> <br>Which of the following can you infer from this??",
       "choice_a":"When a host with the source IP <code>1.1.1.1</code> sends a packet, the NAT router will translate the source address to <code>10.0.12.1.</code>",
       "choice_b":"When a host on the inside sends a packet to the destination IP <code>10.0.12.1</code>, the NAT router will translate the destination to <code>1.1.1.1. </code>",
       "choice_c":"When a host on the inside sends a packet to the destination IP <code>1.1.1.1</code>, the NAT router will translate the destination to <code>10.0.12.1. </code>",
       "choice_d":"When a host with the source IP <code>10.0.12.1</code> sends a packet, the NAT router will translate the source address to <code>1.1.1.1. </code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"It's crucial to carefully read the output of the translation table. The outside local address is <code>1.1.1.1</code> and the outside global address is <code>10.0.12.1</code>, whereas the inside local and inside global addresses are blank. This indicates an outside static NAT configuration. Recalling that only inside hosts can resolve local addresses, we can infer that the inside host sends traffic to the destination IP 1<code>.1.1.1</code>, and the NAT router translates the destination to the global address <code>10.0.12.1. </code>"
    },
    {
       "id":242,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is <italic>not</italic> a multicast IP address?",
       "choice_a":"<code>224.0.0.0</code>",
       "choice_b":"<code>240.0.0.1</code>",
       "choice_c":"<code>239.255.255.1</code>",
       "choice_d":"<code>224.0.1.0</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Multicast IP addresses range from <code>224.0.0.0</code> to <code>239.255.255.255</code> inclusive."
    },
    {
       "id":243,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following best describes IP multicast?",
       "choice_a":"One-to-many",
       "choice_b":"One-to-one",
       "choice_c":"Many-to-one",
       "choice_d":"Destination-based routing",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Multicast distributes a single frame or packet to multiple receivers. Unicast, on the other hand, involves sending a packet to one and only one receiver. Destination-based routing refers to routing a packet according to its destination IP address and is what unicast routing is usually based on. In contrast, multicast routing is based on the location of the group members or receivers."
    },
    {
       "id":244,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What distinguishes a multicast MAC from a unicast MAC address?",
       "choice_a":"In a multicast address, the second-to-left hexadecimal digit is always odd.",
       "choice_b":"In a multicast address, the leftmost hexadecimal digit is always even.",
       "choice_c":"In a multicast address, the second-to-last hexadecimal digit is always zero.",
       "choice_d":"In a unicast address, the second-to-left hexadecimal digit is always zero.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The second-to-left hexadecimal digit of a multicast address is always odd, whereas the same digit of a unicast address is always either even or zero."
    },
    {
       "id":245,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following are true of an Ethernet frame? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> It never contains a multicast source address.</li><li> It may be flooded to all devices in a subnet.</li><li> It never contains a multicast destination address.</li><li> It has a TTL.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"An Ethernet frame can't contain a multicast source address and doesn't have a TTL. It may contain a multicast destination address, and it may be flooded to all devices in a subnet (e.g., a broadcast frame)."
    },
    {
       "id":246,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is true of a multicast IP packet? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> It always contains a multicast destination address.</li><li> It may contain a multicast source address.</li><li> It always uses IP protocol 103.</li><li> It may have a TTL of 1.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"A, D",
       "choice_d":"C, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"A multicast IP packet always has a multicast destination address (that's what makes it a multicast packet), and it may have a TTL of 1. It will never contain a multicast source address."
    },
    {
       "id":247,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following protocols does a multicast receiver use to join a group?",
       "choice_a":"IGMP",
       "choice_b":"PIM",
       "choice_c":"OSPF",
       "choice_d":"RP",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Multicast receivers send IGMP Membership Report messages to join a group."
    },
    {
       "id":248,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following do routers use to request multicast traffic for a group? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> PIM Prune</li><li> IGMP Membership Report</li><li> PIM Join</li><li> PIM Graft</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"PIM routers running in sparse mode use PIM Joins to request traffic for a group, whereas those running in dense mode use Grafts. PIM Prunes indicating that a router doesn't want to receive traffic for a group. Routers do not request traffic using IGMP."
    },
    {
       "id":249,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"A router running PIM has a single multicast RIB entry marked <code> (*, 239.9.9.9) </code>. What does this indicate?",
       "choice_a":"The router has sent an IGMP Query to <code>239.9.9.9</code>.",
       "choice_b":"A receiver has sent an IGMP Membership Report to <code>239.9.9.9</code>.",
       "choice_c":"The router has sent a PIM Join/Graft to <code>239.9.9.9</code>.",
       "choice_d":"A receiver has sent an IGMP Query to <code>239.9.9.9</code>.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"When a receiver joins a multicast group, it sends an IGMP Membership Report to the group address. Receivers don't send IGMP Queries. Routers don't send IGMP Queries or PIM messages to group addresses."
    },
    {
       "id":250,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What multicast address do routers send PIM Hello messages to?",
       "choice_a":"<code>224.0.0.13</code>",
       "choice_b":"<code>224.0.0.1</code>",
       "choice_c":"<code>239.0.0.13</code>",
       "choice_d":"<code>239.0.0.1</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"PIM Hello messages are sent to <code>224.0.0.13</code>."
    },
    {
       "id":251,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What multicast address are IGMP Queries sent to?",
       "choice_a":"<code>224.0.0.13</code>",
       "choice_b":"<code>239.0.0.13</code>",
       "choice_c":"<code>224.0.0.1</code>",
       "choice_d":"The multicast group address being queried",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Routers send IGMP Queries to <code>224.0.0.1</code>. Receivers send IGMP Membership Reports to the multicast group address they want to receive traffic for."
    },
    {
       "id":252,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is true of NTP? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> An authoritative clock has a stratum of 1.</li><li> An authoritative clock has a stratum of 0.</li><li> It uses UDP port 123.</li><li> It uses UDP port 321.</li><li> It requires an atomic reference clock.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, C",
       "correct_answer":"E",
       "explanation":"NTP uses UDP port 123. The reference clock has a stratum of 1. An atomic clock isn't required."
    },
    {
       "id":253,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"When does the destination MAC address of a frame <italic>not</italic>correspond to the destination IP address in the encapsulated packet?",
       "choice_a":"When the destination IP address is in the same subnet as the sender",
       "choice_b":"When the IP packet must be routed",
       "choice_c":"When the frame must be switched",
       "choice_d":"The destination MAC address of a frame always corresponds to the destination IP address in the encapsulated packet.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"When the source and destination IP addresses are in different subnets, the IP packet must be routed. The sender encapsulates the packet in an Ethernet frame addressed to its next hop router's media access control (MAC) address."
    },
    {
       "id":254,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following does the Cisco Express Forwarding (CEF) adjacency table contain?",
       "choice_a":"Next-hop address",
       "choice_b":"IP prefix",
       "choice_c":"Incoming interface",
       "choice_d":"A precomputed layer 2 header",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The adjacency table contains the layer 3 protocol (e.g., IPv4 or IPv6), the outgoing interface, and a precomputed layer 2 header."
    },
    {
       "id":255,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following does the CEF FIB contain? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Next-hop address</li><li> MAC address</li><li> Outgoing interface</li><li> A precomputed layer 2 header</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The Cisco Express Forwarding (CEF) Forwarding Information Base (FIB) contains an IP network prefix, the next-hop address, and the outgoing interface."
    },
    {
       "id":256,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which is considered <italic>last</italic> when selecting a root bridge?",
       "choice_a":"Port number",
       "choice_b":"Bridge priority",
       "choice_c":"Port cost",
       "choice_d":"Port priority",
       "choice_e":"Burned-in address",
       "correct_answer":"E",
       "explanation":"The bridge with the lowest bridge priority becomes the root. If the priorities are equal, then the bridge with the lowest burned-in media access control (MAC) address (bridge identifier) becomes the root."
    },
    {
       "id":257,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which is considered <italic>last</italic> when selecting a root port?",
       "choice_a":"Port number",
       "choice_b":"Bridge priority",
       "choice_c":"Port cost",
       "choice_d":"Port priority",
       "choice_e":"Burned-in address",
       "correct_answer":"D",
       "explanation":"Spanning Tree first considers the port with the lowest path cost to the root. If costs are equal, then it selects the port with the lowest designated port ID, which is determined by the port priority."
    },
    {
       "id":258,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What's the Spanning Tree port cost of a 100 Mbps interface?",
       "choice_a":2,
       "choice_b":16,
       "choice_c":19,
       "choice_d":100,
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The cost of a 100 Mbps interface is 19."
    },
    {
       "id":259,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What's the Spanning Tree port cost of a 10 Gbps interface?",
       "choice_a":2,
       "choice_b":4,
       "choice_c":10,
       "choice_d":19,
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The Spanning Tree port cost of a 10 Gbps interface is 2."
    },
    {
       "id":260,
       "topic_id":3,
       "practice_test_id":4,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"All the ports on a Spanning Tree bridge are forwarding. What are the possible roles of these ports? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Root</li><li> Designated</li><li> Alternate</li><li> Backup</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Forwarding ports are either root ports or designated ports."
    },
    {
       "id":261,
       "topic_id":3,
       "practice_test_id":5,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which Spanning Tree mode uses port timers?",
       "choice_a":"802.1Q",
       "choice_b":"802.1D",
       "choice_c":"802.1w",
       "choice_d":"802.1s",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"802.1D Spanning Tree Protocol (STP) uses port timers, but 802.1w Rapid Spanning Tree Protocol (RSTP) and 802.1s Multiple STP (MSTP) do not. 802.1Q isn't a Spanning Tree mode; it is used to communicate tagged virtual LANs (VLANs) between switches."
    },
    {
       "id":262,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"How frequently does 802.1w send configuration BPDUs?",
       "choice_a":"Every second",
       "choice_b":"Every 2 seconds",
       "choice_c":"Every 5 seconds",
       "choice_d":"Every 10 seconds",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Here's how the election process works: Initially, each switch assumes it's the root. It places all of its ports into a listening state, and every 2 seconds, it sends a configuration/Hello Bridge Protocol Data Unit (BPDU) out of every nonblocking port."
    },
    {
       "id":263,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What does a Spanning Tree bridge do when it receives a BPDU with the topology change (TC) bit set?",
       "choice_a":"Clears its MAC address table completely",
       "choice_b":"Deletes any MAC addresses learned from the port on which it received the BPDU",
       "choice_c":"Clears its MAC address table for all ports except the port on which it received the BPDU",
       "choice_d":"Blocks all ports",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"When another bridge receives a Bridge Protocol Data Unit (BPDU) with the topology change (TC) bit set, it clears its MAC address table for all ports except the port on which it received the BPDU."
    },
    {
       "id":264,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which Rapid Spanning Tree link type is associated with PortFast?",
       "choice_a":"Point-to-point",
       "choice_b":"Point-to-point edge",
       "choice_c":"Shared",
       "choice_d":"Shared edge",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The point-to-point edge type is reserved for edge devices that don't run Spanning Tree, such as computers, servers, and phones. An edge port skips over the learning state and transitions instantly to a forwarding state."
    },
    {
       "id":265,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"A switch has four equal cost paths to the root bridge. It's receiving BPDUs with the following designated port priorities. Which of these designated port identifiers are arriving on the root port?",
       "choice_a":128.1,
       "choice_b":128.6,
       "choice_c":128.7,
       "choice_d":129.7,
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Assuming equal costs to the root, the port with the lowest designated port identifier is chosen as the root port."
    },
    {
       "id":266,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which is a restriction of per-VLAN Spanning Tree?",
       "choice_a":"It's incompatible with PortFast.",
       "choice_b":"It's incompatible with 802.1D.",
       "choice_c":"Bridge priorities must be configured in increments of 4,096.",
       "choice_d":"Port timers can't be used.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"To distinguish Bridge Protocol Data Units (BPDUs) for different virtual LANs (VLANs), per-VLAN Spanning Tree uses the bridge priority field. The other options aren't restrictions of per-VLAN Spanning Tree."
    },
    {
       "id":267,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following would you most likely use with PortFast?",
       "choice_a":"Loop guard",
       "choice_b":"UDLD",
       "choice_c":"BPDU filter",
       "choice_d":"BPDU guard",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Bridge Protocol Data Unit (BPDU) Guard error-disables a port if it receives a BPDU. This is useful if someone accidentally connects a cheap workgroup switch to a port that's meant for an end user. The interface command to enable it is <code>spanning-tree bpduguard enable.</code>"
    },
    {
       "id":268,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following Spanning Tree features will shut down a port if it receives a superior BPDU?",
       "choice_a":"BPDU filter",
       "choice_b":"UDLD",
       "choice_c":"Loop Guard",
       "choice_d":"Root Guard",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Root Guard is a Spanning Tree extension that prevents another switch from becoming root. If the switch receives a superior Bridge Protocol Data Unit (BPDU) on the port, it will place the port into a Root Inconsistent state and stop forwarding traffic to or from that port."
    },
    {
       "id":269,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which of the following allows mapping multiple VLANs to a single Spanning Tree instance?",
       "choice_a":"802.1D",
       "choice_b":"802.1w",
       "choice_c":"802.1s",
       "choice_d":"802.1m",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Multiple Spanning Tree (802.1s) allows mapping multiple VLANs to a single instance. Spanning Tree Protocol (802.1D) and Rapid Spanning Tree Protocol (802.1w) do not. 802.1m isn't a valid Spanning Tree standard."
    },
    {
       "id":270,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"What must Multiple Spanning Tree (MST) switches have in common to be in the same region?",
       "choice_a":"None of these",
       "choice_b":"VLAN-to-instance mappings",
       "choice_c":"Number of VLANs",
       "choice_d":"Region password",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"A Multiple Spanning Tree (MST) region is a collection of MST instances that share a common region name, revision number, and list of VLAN-to-instance mappings."
    },
    {
       "id":271,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"You've configured two connected switches to negotiate an 802.1Q trunk, but the trunk isn't forming. Which of the following commands may solve the problem?",
       "choice_a":"<code>switchport nonegotiate</code>",
       "choice_b":"<code>no switchport nonegotiate</code>",
       "choice_c":"<code>switchport trunk encapsulation dot1q</code>",
       "choice_d":"<code>switchport mode trunk</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Enabling Dynamic Trunk Protocol (DTP) with the <code>no switchport nonegotiate</code> command will allow the switches to negotiate a trunk."
    },
    {
       "id":272,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Assuming a destination IP prefix of <code>1.3.3.7/32</code>, which combination of IP prefix and administrative distance will form the route that will be chosen to reach the prefix?",
       "choice_a":"<code>1.3.0.0/16</code>, administrative distance 1",
       "choice_b":"<code>1.3.3.0/24</code>, administrative distance 2",
       "choice_c":"<code>1.3.3.7/32</code>, administrative distance 254",
       "choice_d":"<code>1.3.3.0/27</code>, administrative distance 1",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"When it comes to IP routing, the longest (or closest) match wins."
    },
    {
       "id":273,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Assuming a destination IP prefix of <code>1.3.3.7/32</code>, which combination of IP prefix and administrative distance will form the route that will be chosen to reach the prefix?",
       "choice_a":"<code>1.3.0.0/16</code>, administrative distance 1",
       "choice_b":"<code>1.3.3.0/24</code>, administrative distance 1",
       "choice_c":"<code>1.3.0.0/8</code>, administrative distance 2",
       "choice_d":"<code>1.3.3.0/24</code>, administrative distance 2",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"When it comes to IP routing, the longest (or closest) match wins. If there are multiple longest-match routes, then the lowest administrative distance wins."
    },
    {
       "id":274,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which routing protocols consider hop count to determine the next hop? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Lisp</li><li> OSPF<.B> <C> BGP</li><li> EIGRP</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Open Shortest Path First (OSPF) and Enhanced Interior Gateway Routing Protocol (EIGRP) both use a derivative of hop count to determine the next hop. Border Gateway Protocol (BGP) uses autonomous system (AS) path length without considering the hop count in any way. Lisp, even if you consider it a routing protocol, doesn't use hop count."
    },
    {
       "id":275,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Two OSPF routers are failing to form an adjacency. Which of the following could be the reason?",
       "choice_a":"MTU mismatch",
       "choice_b":"Duplicate MTUs",
       "choice_c":"Network type mismatch",
       "choice_d":"RID mismatch",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"A maximum transmission unit (MTU) mismatch will cause Open Shortest Path First (OSPF) routers not to form an adjacency."
    },
    {
       "id":276,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following Enhanced Interior Gateway Routing Protocol (EIGRP) DUAL states for a route is associated with network instability?",
       "choice_a":"Passive",
       "choice_b":"Queried",
       "choice_c":"Successor",
       "choice_d":"Active",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Confusingly, \u0022active\u0022 refers to the Diffusing Update Algorithm (DUAL) algorithm actively recomputing the cost to the prefix. In reality, it's not the route that's active, but the DUAL algorithm working to figure out a new path to the prefix. To put it succinctly, an active route is a route in flux."
    },
    {
       "id":277,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What happens if you use issue the EIGRP router configuration command <code>network 10.9.9.0</code>?",
       "choice_a":"EIGRP will advertise 10.0.0.0/8</code>.",
       "choice_b":"EIGRP won't advertise anything.",
       "choice_c":"EIGRP won't form an adjacency over any interfaces with addresses in the <code>10.0.0.0/8</code> range.",
       "choice_d":"EIGRP will advertise <code>10.9.9.0/24</code>.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"If you don't specify a subnet mask, Enhanced Interior Gateway Routing Protocol (EIGRP) will use the classful mask, which in this case is <code>10.0.0.0/8</code>."
    },
    {
       "id":278,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What LSA type does OSPF use to advertise a default route?",
       "choice_a":"Type 3",
       "choice_b":"Type 4",
       "choice_c":"Type 5",
       "choice_d":"Type 6",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Open Shortest Path First (OSPF) advertises the default route using a Type 5 external link-state advertisement (LSA)."
    },
    {
       "id":279,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which command is required to have OSPF originate a default route with <code>203.0.113.2</code> as the next hop?",
       "choice_a":"<code>default originate</code>",
       "choice_b":"<code>area 0 range 0.0.0.0 0.0.0.0</code>",
       "choice_c":"<code>ip route 0.0.0.0 0.0.0.0 203.0.113.2</code>",
       "choice_d":"<code>redistribute static</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"To have Open Shortest Path First (OSPF) originate a default route, the route must exist in the IP routing table."
    },
    {
       "id":280,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"In which of the following network types is an OSPF designated router unnecessary?",
       "choice_a":"Inter-area",
       "choice_b":"Point-to-point",
       "choice_c":"Multicast",
       "choice_d":"Multiaccess",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"A designated router (DR) isn't necessary on a point-to-point network type."
    },
    {
       "id":281,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Two OSPF routers, R1 and R2, are connected to the same Ethernet network. R1 is configured with an OSPF interface priority of 1, and R2 is configured with an interface priority of 2. R2 boots and becomes active first, followed by R1. Which is the designated router (DR) and why? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> R1</li><li> R2</li><li> It has a lower priority.</li><li> It has a higher priority.</li><li> It became active first.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"B, E",
       "correct_answer":"E",
       "explanation":"The first Open Shortest Path First (OSPF) router to become active on a subnet becomes the designated router (DR) for the subnet."
    },
    {
       "id":282,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"R1, R2, R3, and R4 are OSPF routers connected to the same Ethernet segment. R1 is the designated router (DR), and R2 is the backup DR (BDR). R4 has an interface priority of 0. What happens if R1 fails?",
       "choice_a":"R2 becomes the DR.",
       "choice_b":"R2 remains the BDR.",
       "choice_c":"R4 becomes the DR.",
       "choice_d":"R3 becomes the DR.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Because R2 is the backup designated router (BDR), it will become the designated router (DR). R3 will become the new BDR."
    },
    {
       "id":283,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What is the hold time for BGP?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"179 seconds",
       "choice_d":"180 seconds",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The hold time is three times the hello interval, which is 60 seconds."
    },
    {
       "id":284,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following influences how traffic ingresses a BGP autonomous system?",
       "choice_a":"Origin",
       "choice_b":"Local preference",
       "choice_c":"Multi-exit discriminator (MED)",
       "choice_d":"Weight",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The multi-exit discriminator (MED)-also called the metric-influences how traffic ingresses an autonomous system (AS). A lower MED is more preferred. Suppose you have two Border Gateway Protocol (BGP) routers in your AS that are peered to routers in AS 64999. If you want traffic from AS 64999 to ingress a particular router, you can configure that router to advertise a lower MED."
    },
    {
       "id":285,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which BGP attribute is Cisco-proprietary?",
       "choice_a":"Local preference",
       "choice_b":"Weight",
       "choice_c":"Multi-exit discriminator (MED)",
       "choice_d":"Remote preference",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Weight is a Cisco-proprietary attribute that's only locally significant, so it's not advertised to other routers."
    },
    {
       "id":286,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following is a difference between BGP and interior gateway protocols (IGPs)?",
       "choice_a":"BGP is a link-state protocol.",
       "choice_b":"IGPs use TCP.",
       "choice_c":"BGP uses IP protocol 179.",
       "choice_d":"IGP neighbors must share a subnet.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"An interior gateway protocol (IGP) like Open Shortest Path First (OSPF) or Enhanced Interior Gateway Routing Protocol (EIGRP) requires neighbors to share a subnet to form an adjacency. Border Gateway Protocol (BGP) on the other hand, uses the Transmission Control Protocol (TCP), so neighbors don't have to share a subnet."
    },
    {
       "id":287,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which command will show you which autonomous system a BGP neighbor belongs to?",
       "choice_a":"<code>show ip bgp summary</code>",
       "choice_b":"<code>show ip route</code>",
       "choice_c":"<code>show ip protocol</code>",
       "choice_d":"<code>show ip route bgp</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The command <code>show ip bgp summary</code> will show Border Gateway Protocol (BGP) neighbors and their respective autonomous systems."
    },
    {
       "id":288,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following does BGP advertise?",
       "choice_a":"Cost",
       "choice_b":"The best path to a prefix",
       "choice_c":"All paths to a prefix",
       "choice_d":"Weight",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Border Gateway Protocol (BGP) advertises only the best path to a prefix."
    },
    {
       "id":289,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following BGP output: <br> <code>s   10.0.23.0/29     203.0.113.2                            0 65550 65004 i</code> <br>  <code>s>                   10.0.14.4             3072             0 65004 i</code> <br>Inferring from the output, what command was issued on this router?",
       "choice_a":"<code>ip prefix-list R4-summary permit 10.0.23.0/29</code>",
       "choice_b":"<code>aggregate-address 10.0.0.0 255.255.0.0 summary-only</code>",
       "choice_c":"<code>aggregate-address 10.0.0.0 255.255.0.0</code>",
       "choice_d":"<code>show ip route</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The output indicates that Border Gateway Protocol (BGP) is creating an aggregate route for <code>10.0.0.0/16</code> and suppressing the component routes. This is done with the command <code>aggregate-address 10.0.0.0 255.255.0.0 summary-only. </code>"
    },
    {
       "id":290,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which prefix matches the IP prefix list created by the command <code>ip prefix-list mylist permit 0.0.0.0/0 le 24</code>?",
       "choice_a":"<code>1.0.0.0/32</code>",
       "choice_b":"<code>1.0.0.0/8</code>",
       "choice_c":"<code>0.0.0.0/32</code>",
       "choice_d":"<code>192.0.2.1/30</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"This will cover all IP address ranges from <code>0.0.0.0 to 255.255.255.255</code> and all prefix lengths from 0 to 24."
    },
    {
       "id":291,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following command: <br> <code>route-map mymap permit 10</code> <br>Which of the following is true of the resulting route map? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> It denies all routes.</li><li> It permits all routes.</li><li> It matches no routes.</li><li> It matches all routes.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"B, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"An empty route map clause with no<code>match</code> statement will match all routes."
    },
    {
       "id":292,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following command: <br> <code>ip prefix-list external permit 24.0.0.0/8 ge 28 le 32</code> <br>Which prefix will the prefix list match?",
       "choice_a":"<code>24.0.0.0/8</code>",
       "choice_b":"<code>24.0.0.0/16</code>",
       "choice_c":"<code>24.9.6.0/24</code>",
       "choice_d":"<code>24.0.0.1/32</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The <code>24.0.0.0/8</code> will match prefixes ranging from <code>24.0.0.0 to 24.255.255.255</code>, while <code>ge 28 le 32 </code>in the prefix list will match prefix lengths between 28 and 32 bits, inclusive. The only one that fits the bill is <code>24.0.0.1/32</code>."
    },
    {
       "id":293,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What is the relationship between IP and Ethernet multicast?",
       "choice_a":"IP multicast requires Ethernet multicast.",
       "choice_b":"Ethernet multicast requires IP multicast.",
       "choice_c":"There's a one-to-one mapping between Ethernet multicast addresses and IP multicast addresses.",
       "choice_d":"There is none.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"IP multicast depends on Ethernet multicast."
    },
    {
       "id":294,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following multicast technologies uses Join/Graft messages?",
       "choice_a":"Multicast OSPF",
       "choice_b":"PIM dense mode",
       "choice_c":"PIM spare mode",
       "choice_d":"IGMP",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Protocol-Independent Multicast (PIM) dense mode and PIM sparse (not spare) mode use Join/Graft messages."
    },
    {
       "id":295,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Traffic sent to which of the following multicast addresses can't leave a broadcast domain?",
       "choice_a":"<code>224.0.1.255</code>",
       "choice_b":"<code>239.255.255.255</code>",
       "choice_c":"<code>224.0.0.255</code>",
       "choice_d":"<code>224.255.255.255</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Addresses in the local network control block (<code>224.0.0.0/24</code>) can't leave a broadcast domain."
    },
    {
       "id":296,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is a multicast MAC address?",
       "choice_a":"<code>0100.e500.c0a1</code>",
       "choice_b":"<code>0100.5e7a.0000</code>",
       "choice_c":"<code>0000.e500.beef</code>",
       "choice_d":"<code>0000.5e00.0000</code>",
       "choice_e":"<code>3330.0000.ffff</code>",
       "correct_answer":"B",
       "explanation":"IPv4 multicast addresses range from <code>0100.5e00.000 through <code>0100.5e7f.ffff</code>. IPv6 multicast addresses range from <code>3333.0000.0000</code> to <code>3333.ffff.ffff</code>."
    },
    {
       "id":297,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What feature does IGMPv3 add that IGMPv2 lacks?",
       "choice_a":"Source filtering",
       "choice_b":"Snooping",
       "choice_c":"Membership report",
       "choice_d":"Membership query",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Internet Group Management Protocol version 3 (IGMPv3) (RFC 3376) adds the ability to request multicast traffic from a specific source-a feature called source filtering."
    },
    {
       "id":298,
       "topic_id":3,
       "practice_test_id":2,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"What feature reduces mitigates flooding of multicast frames?",
       "choice_a":"IGMP sniffing",
       "choice_b":"PIM sparse mode",
       "choice_c":"IGMP snooping",
       "choice_d":"Multicast control",
       "choice_e":"Reverse path forwarding",
       "correct_answer":"C",
       "explanation":"Switches by default will flood multicast packets the same way they flood broadcasts and unknown unicasts. But Cisco switches support a feature called Internet Group Management Protocol (IGMP) snooping wherein the switch will sniff IGMP Membership Reports to determine which ports multicast group traffic should be forwarded out of."
    },
    {
       "id":299,
       "topic_id":3,
       "practice_test_id":"",
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which router in a multicast topology running PIM sparse mode receives multicast traffic for all groups?",
       "choice_a":"Rendezvous point",
       "choice_b":"Radial polarizer",
       "choice_c":"Source root",
       "choice_d":"Branch router",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Multicast sources send their multicast traffic to the rendezvous point (RP), while receivers send Join/Prune requests toward the RP. Essentially, the RP becomes the hub or rendezvous point for all multicast traffic in the network."
    },
    {
       "id":300,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Wireless",
       "question":"Which of the following 802.11 standards can achieve the highest data rate?",
       "choice_a":"802.11x",
       "choice_b":"802.11ax",
       "choice_c":"802.11g",
       "choice_d":"802.11ac",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"802.11ax has a maximum data rate of 9.6 Gbps."
    },
    {
       "id":301,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which OSPF LSA type is not confined to a normal area?",
       "choice_a":"Type 1",
       "choice_b":"Type 2",
       "choice_c":"Type 3",
       "choice_d":"Type 5",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Unlike type 1, 2, and 3 link-state advertisements (LSAs) that remain within an area, Type 5 AS external LSAs are flooded across all normal Open Shortest Path First (OSPF) areas."
    },
    {
       "id":302,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"If no loopback interfaces are configured, and if no router ID is configured, where will an OSPF router get its router ID?",
       "choice_a":"Highest numbered IPv4 address on a physical interface",
       "choice_b":"Lowest numbered IPv4 address on a physical interface",
       "choice_c":"It will randomly generate one.",
       "choice_d":"It will use the RID <code>0.0.0.0. </code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"If you don't explicitly configure it, the router ID (RID) will be the highest numbered loopback IP address on the router when the Open Shortest Path First (OSPF) process starts. If there are no loopbacks configured, the RID will be the highest numbered IPv4 address configured on a physical interface."
    },
    {
       "id":303,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What causes Open Shortest Path First (OSPF) routers to remain in a two-way state with each other?",
       "choice_a":"Duplicate router ID (RID)",
       "choice_b":"Point-to-point network type",
       "choice_c":"Absence of a designated router (DR)",
       "choice_d":"Neither is a designated router (DR) or backup DR.",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Any two OSPF routers that are neither a DR nor a backup DR will never enter into full adjacency with each other, remaining instead in a two-way state since they don't exchange link-state advertisements (LSAs)."
    },
    {
       "id":304,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which OSPF network type is appropriate for loopback interfaces?",
       "choice_a":"Null",
       "choice_b":"Multiaccess",
       "choice_c":"Broadcast",
       "choice_d":"Point-to-point",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The point-to-point network type is used for point-to-point serial interfaces and loopbacks."
    },
    {
       "id":305,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following generates a Type 5 LSA?",
       "choice_a":"ASBR",
       "choice_b":"ABR",
       "choice_c":"BDR",
       "choice_d":"DR",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The routes the Autonomous System Boundary Router (ASBR) redistributes into Open Shortest Path First (OSPF) are called external routes, and the ASBR advertises them using Type 5-external link-state advertisements (LSAs)."
    },
    {
       "id":306,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following summarizes OSPF inter-area routes?",
       "choice_a":"BDR",
       "choice_b":"ABR",
       "choice_c":"ASBR",
       "choice_d":"DR",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"You can configure an area border router (ABR) to summarize inter-area routes."
    },
    {
       "id":307,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which OSPF route is most preferred?",
       "choice_a":"Inter-area",
       "choice_b":"Intra-area",
       "choice_c":"External",
       "choice_d":"Internal",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Intra-area routes are preferred over inter-area and external routes. There's no such thing as an Open Shortest Path First (OSPF) internal route."
    },
    {
       "id":308,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following is not an EIGRP packet type?",
       "choice_a":"Query",
       "choice_b":"Reply",
       "choice_c":"Goodbye",
       "choice_d":"Acknowledgment",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Enhanced Interior Gateway Routing Protocol (EIGRP) includes five packet types: Hellos, Updates, Acknowledgments, Queries, and Replies."
    },
    {
       "id":309,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following EIGRP technologies uses sequence numbers and acknowledgments?",
       "choice_a":"ECMP",
       "choice_b":"RTP",
       "choice_c":"DUAL",
       "choice_d":"TCP",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Enhanced Interior Gateway Routing Protocol (EIGRP) uses a mechanism called the Reliable Transport Protocol (RTP) to deliver EIGRP packets. When sent reliably, the router includes a sequence number for ordering and expects an acknowledgment from the recipient."
    },
    {
       "id":310,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What's the primary purpose of the EIGRP feasibility condition?",
       "choice_a":"Achieving rapid convergence",
       "choice_b":"Maintaining a loop-free topology",
       "choice_c":"Reducing the size of the routing table",
       "choice_d":"Ensuring shortest path routing",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The primary purpose of the feasibility condition is to ensure that the feasible successor offers a loop-free path to the destination in case the best path becomes unavailable."
    },
    {
       "id":311,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following does the EIGRP topology table contain?",
       "choice_a":"Incoming interface",
       "choice_b":"Advertised distance",
       "choice_c":"Feasibility condition",
       "choice_d":"Reported successor",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The Enhanced Interior Gateway Routing Protocol (EIGRP) topology table includes the advertised distance and the feasible (or reported) distance."
    },
    {
       "id":312,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Consider the following commands: <br> <code>int vlan 30</code> <br><code>ip address 3.3.3.3 255.255.255.0</code> <br>Which of the following commands will enable a first-hop redundancy protocol?",
       "choice_a":"<code>glbp 3 ip 3.3.3.3</code>",
       "choice_b":"<code>vrrp 30 ip 3.3.3.3</code>",
       "choice_c":"<code>standby 30 ip 3.3.3.3</code>",
       "choice_d":"<code>hsrp 30 ip 3.3.3.3</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"One significant difference between Virtual Router Redundancy Protocol (VRRP) and other first-hop redundancy protocols (FHRPs) is that with VRRP the virtual IP address can be the same as one of the interface IPs."
    },
    {
       "id":313,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 2",
       "question":"Which two commands when configured on opposite links will create a working EtherChannel? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> channel-group 10 mode desirable</li><li>channel-group 11 mode auto</li><li>channel-group 11 mode on</li><li> channel-group 10 mode passive</li><li>channel-group 10 mode dynamic</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, D",
       "correct_answer":"A",
       "explanation":"The only two commands that will form an EtherChannel are the Port Aggregation Protocol (PAgP) commands <code>channel-group 10 mode desirable</code> and <code>channel-group 11 mode auto. </code>"
    },
    {
       "id":314,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which of the following is <italic>not</italic> a valid Gateway Load-Balancing Protocol (GLBP) load-balancing method?",
       "choice_a":"Round-robin",
       "choice_b":"Weighted",
       "choice_c":"Host-dependent",
       "choice_d":"Destination-based",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"There are three methods: round-robin, weighted, and host-dependent."
    },
    {
       "id":315,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Wireless",
       "question":"Which of the following is affected by radio interference?",
       "choice_a":"Noise floor",
       "choice_b":"EIRP",
       "choice_c":"Free space path loss",
       "choice_d":"RSSI",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"All radio frequencies interfere with one another constantly. Ever present in any environment is a collection of random intertwined signals called noise. Noise consists of radio frequency (RF) energy from other stations, electrical wires, lightning, and even the sun. The sum of all these signals is called the noise floor."
    },
    {
       "id":316,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which command can show what area an OSPF interface resides in?",
       "choice_a":"<code>show ip protocols</code>",
       "choice_b":"<code>show ip ospf database</code>",
       "choice_c":"<code>show ip ospf neighbor</code>",
       "choice_d":"<code>debug ip ospf hello</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Debugging Open Shortest Path First (OSPF) Hellos can show you the interface and the area it resides in. The other commands don't."
    },
    {
       "id":317,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What command will show which interface will be used for forwarding when equal cost multipathing is enabled?",
       "choice_a":"<code>show ip cef exact-route</code>",
       "choice_b":"<code>show ip cef</code>",
       "choice_c":"<code>show ip route</code>",
       "choice_d":"<code>show ip eigrp topology</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The <code>show ip cef exact-route</code> command will show you the specific interface that will be used to forward a packet."
    },
    {
       "id":318,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which global configuration command enables process switching?",
       "choice_a":"<code>ip cef</code>",
       "choice_b":"<code>no ip cef</code>",
       "choice_c":"<code>ip route-cache</code>",
       "choice_d":"<code>no ip route-cache</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The global configuration command <code>no ip cef</code> will disable Cisco Express Forwarding (CEF), enabling process switching."
    },
    {
       "id":319,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which interface configuration command enables process switching?",
       "choice_a":"<code>ip cef</code>",
       "choice_b":"<code>no ip cef</code>",
       "choice_c":"<code>ip route-cache</code>",
       "choice_d":"<code>no ip route-cache</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The interface configuration command <code>no ip route-cache</code> will disable Cisco Express Forwarding (CEF) on the interface, enabling process switching only for that interface."
    },
    {
       "id":320,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"R1 and R2 are BGP routers. R1 is in AS 65001 and has an interface IP address of <code>203.0.113.1/30</code>. It's connected to R2, which has an interface IP address of <code>203.0.113.2/30</code>. Which two commands if configured on these routers will form an iBGP peering? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> On R1: <code>neighbor 203.0.113.1 remote-as 65001</code> </li><li> On R1: <code>neighbor 203.0.113.2 remote-as 65001</code> </li><li> On R2: <code>neighbor 203.0.113.1 remote-as 65001</code> </li><li> On R2: <code>neighbor 203.0.113.2 remote-as 65002</code> </li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"To form an internal Border Gateway Protocol (iBGP) peering, both routers must have the same autonomous system (AS) number. Therefore, on R1 you would configure <code>neighbor 203.0.113.2 remote-as 65001</code> and on R2 you'd configure <code>neighbor 203.0.113.1 remote-as 65001</code>."
    },
    {
       "id":321,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Assuming a router has a connected network of <code>198.51.100.0/30</code>, which BGP configuration command will advertise this prefix using the IGP origin type?",
       "choice_a":"<code>network 198.51.100.0 255.255.255.252</code>",
       "choice_b":"<code>redistribute connected</code>",
       "choice_c":"<code>redistribute connected subnets</code>",
       "choice_d":"<code>network 198.51.100.0</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Redistributed routes are given an origin type of incomplete, whereas prefixes advertised using the <code>network</code> statement are given an origin type of IGP, Border Gateway Protocol (BGP) preferring the latter."
    },
    {
       "id":322,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Consider the following commands: <br> <code>router eigrp 100</code> <br> <code>redistribute bgp 65004 metric 100000 1 255 1 1500</code> <br>On a neighboring EIGRP router, what is the administrative distance of the redistributed routes?",
       "choice_a":1,
       "choice_b":20,
       "choice_c":90,
       "choice_d":100,
       "choice_e":170,
       "correct_answer":"E",
       "explanation":"Routes redistributed into Enhanced Interior Gateway Routing Protocol (EIGRP) are external routes and have an administrative distance of 170."
    },
    {
       "id":323,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"What may occur when BGP learns an eBGP route for a prefix that's already in the IP routing table?",
       "choice_a":"BGP advertises the route that's in the IP routing table.",
       "choice_b":"A RIB failure occurs if the existing route has a higher administrative distance than the eBGP route.",
       "choice_c":"A RIB failure occurs if the existing route has a lower administrative distance than the eBGP route.",
       "choice_d":"BGP installs the route with an administrative distance of 200.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"A routing information base (RIB) failure occurs if the existing route has a lower administrative distance than the exterior Border Gateway Protocol (eBGP) route, which by default has an administrative distance of 20."
    },
    {
       "id":324,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"Layer 3",
       "question":"Which of the following does BGP <italic>not</italic> consider in the best path selection process?",
       "choice_a":"Local preference",
       "choice_b":"Origin type",
       "choice_c":"IGP cost to the next hop",
       "choice_d":"Autonomous System (AS) number",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Border Gateway Protocol (BGP) considers the AS path length, but not the AS number."
    },
    {
       "id":325,
       "topic_id":3,
       "practice_test_id":3,
       "domain":"Infrastructure",
       "sub_domain":"IP Services",
       "question":"Which command uses UDP?",
       "choice_a":"<code>ling</code>",
       "choice_b":"<code>telnet</code>",
       "choice_c":"<code>ping</code>",
       "choice_d":"<code>traceroute</code>",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The <code>traceroute</code> command on Cisco devices uses User Datagram Protocol (UDP)."
    },
    {
       "id":326,
       "topic_id":4,
       "practice_test_id":2,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify NetFlow and Flexible NetFlow",
       "question":"Which of the following will configure an exporter to export NetFlow using the latest version? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>ip flow-export version 9</li><li>transport udp 9</li><li>export-protocol netflow-v9</li><li>flow record all-ip netflow-v8</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"The latest version of NetFlow is 9. <code>ip flow-export version 9</code> configures a flow exporter using NetFlow, whereas <code>export-protocol netflow-v9</code> configures a flow exporter using Flexible NetFlow."
    },
    {
       "id":327,
       "topic_id":4,
       "practice_test_id":4,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify NetFlow and Flexible NetFlow",
       "question":"What's one difference between NetFlow and Flexible NetFlow?",
       "choice_a":"NetFlow doesn't have a Top Talkers feature.",
       "choice_b":"Flexible NetFlow requires fewer commands.",
       "choice_c":"Flexible NetFlow is like the modular QoS CLI.",
       "choice_d":"NetFlow must use UDP port 9995.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"Configuring Flexible NetFlow is much like configuring QoS using the modular QoS CLI."
    },
    {
       "id":328,
       "topic_id":4,
       "practice_test_id":2,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify SPAN/RSPAN/ERSPAN",
       "question":"Which version of SPAN requires the most amount of bandwidth?",
       "choice_a":"ERSPAN",
       "choice_b":"SPAN",
       "choice_c":"RSPAN",
       "choice_d":"CSPAN",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"ERSPAN encapsulates MAC frames in IP, increasing the amount of bandwidth required."
    },
    {
       "id":329,
       "topic_id":4,
       "practice_test_id":5,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify SPAN/RSPAN/ERSPAN",
       "question":"Which of the following versions of SPAN can send traffic to a destination VLAN?",
       "choice_a":"RSPAN",
       "choice_b":"ERSPAN",
       "choice_c":"SPAN",
       "choice_d":"All of these",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Only RSPAN can send traffic to a destination VLAN (the RSPAN VLAN). All versions can capture traffic from a VLAN."
    },
    {
       "id":330,
       "topic_id":4,
       "practice_test_id":2,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify SPAN/RSPAN/ERSPAN",
       "question":"After configuring SPAN to mirror VLAN 20 traffic to a port connected to a packet analyzer, your packet analyzer shows duplicates of every frame. Which of the following configuration commands could be the culprit?",
       "choice_a":"<code>monitor session 1 source vlan 20 tx</code>",
       "choice_b":"<code>monitor session 1 source vlan 20 rx</code>",
       "choice_c":"<code>monitor session 1 source vlan 20 both</code>",
       "choice_d":"<code>monitor session 1 source interface gi0/2-3</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"If you monitor <code>both</code> directions (the default behavior), then you'll get duplicate frames: once when traffic ingresses a port in the VLAN, and another when it egresses a port in the VLAN."
    },
    {
       "id":331,
       "topic_id":4,
       "practice_test_id":"",
       "domain":"Network Assurance",
       "sub_domain":"Diagnose network problems using tools such as debugs, conditional debugs, trace route, ping, SNMP, and syslog",
       "question":"You want to use a conditional IP packet debug to view packets with a destination address of <code>192.168.33.3. </code>Which of the following access lists should you create?",
       "choice_a":"<code>access-list 101 permit ip host 192.168.33.3 any</code>",
       "choice_b":"<code>access-list 101 permit ip any host 192.168.33.3</code>",
       "choice_c":"<code>access-list 11 permit ip any host 192.168.33.3</code>",
       "choice_d":"<code>access-list 101 permit ip any 192.168.33.3</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Because you're specifying a destination, you'll need to use an IP extended access list. The correct command is <code>access-list 101 permit ip any host 192.168.33.3. </code>"
    },
    {
       "id":332,
       "topic_id":4,
       "practice_test_id":2,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify device monitoring using syslog for remote logging",
       "question":"Which Syslog severity level is used for informational messages?",
       "choice_a":1,
       "choice_b":4,
       "choice_c":5,
       "choice_d":6,
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"Severity level 6 is used for informational messages."
    },
    {
       "id":333,
       "topic_id":4,
       "practice_test_id":4,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify IPSLA",
       "question":"You want to use IP SLA to remove a static default route when the next hop (<code>192.168.1.1</code>) goes down. You also want to create a floating static default route with a next hop of <code>192.168.23.2. </code> Which of the following commands will you need to use? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>ip route 0.0.0.0 0.0.0.0 192.168.1.1 254 track 1</li><li>ip route 0.0.0.0 0.0.0.0 192.168.1.1 track 1</li><li>ip route 0.0.0.0 0.0.0.0 192.168.23.2</li><li>ip route 0.0.0.0 0.0.0.0 192.168.23.2 254</li><li>ip route 0.0.0.0 0.0.0.0 192.168.23.2 track 1</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"B, D",
       "correct_answer":"E",
       "explanation":"You need to associate the object tracker with the primary static route, which should have a default administrative distance of 1 (which it does by default). The floating static route should have a higher administrative distance (254 in this case) and should not be associated with an object tracker."
    },
    {
       "id":334,
       "topic_id":4,
       "practice_test_id":5,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify device monitoring using syslog for remote logging",
       "question":"When logged into a router using SSH, you want to prevent debug messages from being displayed. You only want them written to the logging buffer. Which of the following commands will accomplish this? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>logging monitor informational</li><li> <code>logging console informational</li><li>logging buffered informational</li><li> logging buffered debugging</li><li>no logging monitor</li></ol>",
       "choice_a":"A, B, C",
       "choice_b":"B, C, D",
       "choice_c":"C, D, E",
       "choice_d":"A, D, E",
       "choice_e":"B, D, E",
       "correct_answer":"D",
       "explanation":"You can prevent debugging messages from being written to the terminal monitor using the <code>logging monitor informational or no logging monitor</code> commands. The <code>logging buffered debugging</code> command ensures debugging messages get written to the logging buffer."
    },
    {
       "id":335,
       "topic_id":4,
       "practice_test_id":3,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify NetFlow and Flexible NetFlow",
       "question":"Which NetFlow setting controls how frequently NetFlow sends records to the configured collector?",
       "choice_a":"Active Timeout",
       "choice_b":"Hello Timer",
       "choice_c":"Inactive Timeout",
       "choice_d":"Flow Timeout",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The Active Timeout determines how frequently NetFlow sends records to the collector."
    },
    {
       "id":336,
       "topic_id":4,
       "practice_test_id":3,
       "domain":"Network Assurance",
       "sub_domain":"Configure and verify IPSLA",
       "question":"Which administrative distance is considered unreachable?",
       "choice_a":"0",
       "choice_b":"254",
       "choice_c":"255",
       "choice_d":"256",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"An administrative distance of 255 is considered unreachable."
    },
    {
       "id":337,
       "topic_id":5,
       "practice_test_id":1,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"You want to control which commands administrators can run on a router. Which of the following should you configure?",
       "choice_a":"TACACS+ authorization",
       "choice_b":"RADIUS authorization",
       "choice_c":"Local authentication",
       "choice_d":"TACACS+ accounting",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"Terminal Access Controller Access-Control System Plus (TACACS+) supports authorization, authentication, and accounting. Remote Authentication Dial-In User Service (RADIUS) doesn't support command authorization."
    },
    {
       "id":338,
       "topic_id":5,
       "practice_test_id":1,
       "domain":"Security",
       "sub_domain":"Describe the components of network security design",
       "question":"Which of the following can authenticate only a machine but not a user?",
       "choice_a":"PEAP",
       "choice_b":"802.1X",
       "choice_c":"MAC authentication bypass",
       "choice_d":"WebAuth",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"MAC authentication bypass is the only option that can authenticate a machine but not a user."
    },
    {
       "id":339,
       "topic_id":5,
       "practice_test_id":1,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"Which of the following can't be used to block ARP packets or Spanning Tree BPDUs? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Port ACL</li><li> VLAN access map</li><li> MAC ACL</li><li> Extended IP ACL</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"You can't use a port access control list (ACL) to block certain control plane traffic, including ARP and Spanning Tree BPDUs. You also can't use an extended IP ACL because ARP and Spanning Tree Protocol (STP) don't use IP."
    },
    {
       "id":340,
       "topic_id":5,
       "practice_test_id":4,
       "domain":"Security",
       "sub_domain":"Configure and verify device access control",
       "question":"Which command prevents insecure telnet connections to a router?",
       "choice_a":"<code>no exec</code>",
       "choice_b":"<code>transport input ssh</code>",
       "choice_c":"<code>telnet input none</code>",
       "choice_d":"<code>exec-timeout 0 0</code>",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Unless you explicitly enable telnet, it's going to be disabled."
    },
    {
       "id":341,
       "topic_id":5,
       "practice_test_id":2,
       "domain":"Security",
       "sub_domain":"Configure and verify device access control",
       "question":"Which command enables authentication using local usernames?",
       "choice_a":"<code>privilege level 15</code>",
       "choice_b":"<code>transport input ssh</code>",
       "choice_c":"<code>login local</code>",
       "choice_d":"<code>login</code>",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The <code>login local</code> command requires authenticating using a local username. The <code>login</code> command by itself requires a password to be set on the line itself."
    },
    {
       "id":342,
       "topic_id":5,
       "practice_test_id":5,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"What protocol and port does TACACS+ use? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> TCP</li><li> UDP</li><li>49</li><li>1812</li><li>1813</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, C",
       "correct_answer":"E",
       "explanation":"TACACS+ uses TCP port 49."
    },
    {
       "id":343,
       "topic_id":5,
       "practice_test_id":2,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"What official protocol and port does RADIUS use? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>1645</li><li> UDP</li><li>1812</li><li> TCP</li><li>49</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"D, E",
       "choice_e":"A, C",
       "correct_answer":"B",
       "explanation":"RADIUS officially uses UDP port 1812 for authentication."
    },
    {
       "id":344,
       "topic_id":5,
       "practice_test_id":2,
       "domain":"Security",
       "sub_domain":"Configure and verify device access control",
       "question":"You've configured TACACS+ authentication with local fallback. You've also configured authorization using the following command: <br> <code>aaa authorization exec default group aaaservers</code> <br>What will be true when all the servers in the group <code>aaaservers</code> fail? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Local users won't be able to access the CLI upon logging in.</li><li> TACACS+ users will be able to authenticate.</li><li> Users already in the CLI will be able to run commands.</li><li> Local users won't be able to authenticate.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"A, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"Local users, even if they authenticate, won't be authorized to obtain a CLI shell because the <code>if-authenticated</code> keyword is missing. Users who are already in the CLI will be able to run commands because command authorization is not configured."
    },
    {
       "id":345,
       "topic_id":5,
       "practice_test_id":4,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"Which of the following configurations represents a port access control list?",
       "choice_a":"<code>SW1(config-if)# switchport</code> <br> <code>SW1(config-if)# ip access-group myacl in</code>",
       "choice_b":"<code>SW1(config-if)# no switchport</code> <br> <code>SW1(config-if)# mac access-group myacl in</code>",
       "choice_c":"<code>SW1(config-if)# no switchport</code> <br> <code>SW1(config-if)# ip access-group myacl in</code>",
       "choice_d":"<code>SW1(config-if)# switchport</code> <br> <code>SW1(config-if)# vlan filter VACL20 vlan-list 20</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"A port ACL is an ACL applied to a switchport."
    },
    {
       "id":346,
       "topic_id":5,
       "practice_test_id":5,
       "domain":"Security",
       "sub_domain":"Describe the components of network security design",
       "question":"Which of the following runs malware in a virtual sandbox to analyze its behavior?",
       "choice_a":"Firepower NGFW",
       "choice_b":"AMP for Endpoints",
       "choice_c":"Umbrella",
       "choice_d":"AMP ThreatGrid",
       "choice_e":"",
       "correct_answer":"D",
       "explanation":"AMP ThreatGrid runs suspicious executables in a virtual environment to analyze its behavior to determine whether it's malware."
    },
    {
       "id":347,
       "topic_id":5,
       "practice_test_id":2,
       "domain":"Security",
       "sub_domain":"Describe the components of network security design",
       "question":"Which of the following operates at layer 3?",
       "choice_a":"EAP",
       "choice_b":"802.1X",
       "choice_c":"RADIUS",
       "choice_d":"WPA2",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"RADIUS uses IP, so it operates at layer 3. 802.1X and WPA2 operate at layer 2. EAP is an application protocol."
    },
    {
       "id":348,
       "topic_id":5,
       "practice_test_id":"",
       "domain":"Security",
       "sub_domain":"Configure and verify wireless security features",
       "question":"Which of the following is not compatible with 802.1X?",
       "choice_a":802.3,
       "choice_b":"TACACS+",
       "choice_c":"PEAP",
       "choice_d":"RADIUS",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"TACACS+ can't be used for EAP authentication, implying it can't be used with 802.1X. 802.1X can use RADIUS, PEAP, and obviously 802.3."
    },
    {
       "id":349,
       "topic_id":5,
       "practice_test_id":2,
       "domain":"Security",
       "sub_domain":"Describe the components of network security design",
       "question":"Which proprietary feature allows simultaneous authentication of a user and endpoint?",
       "choice_a":"WebAuth",
       "choice_b":"EAPoL",
       "choice_c":"EAP-FAST",
       "choice_d":"MAB",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"EAP-FAST is a proprietary protocol that supports EAP chaining, which allows simultaneous authentication of both the user and the machine."
    },
    {
       "id":350,
       "topic_id":5,
       "practice_test_id":3,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"Consider the following access list: <br> <code>Extended IP access list NoOSPF</code> <code>10 deny ospf any host 224.0.0.5 log (10 matches)</code> <br> <code>20 permit ip any any (1000 matches) </code> <br>What can you conclude about this access list?",
       "choice_a":"Packets sent to 224.0.0.5 are fast switched.",
       "choice_b":"All packets are process switched.",
       "choice_c":"Packets sent to 224.0.0.5 are process switched.",
       "choice_d":"All packets are fast switched.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The <code>log</code> keyword causes matching packets to be process switched, increasing central processing unit (CPU) utilization."
    },
    {
       "id":351,
       "topic_id":5,
       "practice_test_id":3,
       "domain":"Security",
       "sub_domain":"Configure and verify infrastructure security features",
       "question":"What can you conclude from the following output? <img src='/question_assets/ccnp/16_image1.png'></img>",
       "choice_a":"QoS queuing is disabled.",
       "choice_b":"Process switching is disabled.",
       "choice_c":"CEF is enabled.",
       "choice_d":"CEF is disabled.",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"The output indicates that fast switching is occurring, which means Cisco Express Forwarding (CEF) is enabled. The fact that some process switching is also occurring means that process switching is not disabled."
    },
    {
       "id":352,
       "topic_id":5,
       "practice_test_id":3,
       "domain":"Security",
       "sub_domain":"Describe the components of network security design",
       "question":"Which protocol uses TCP?",
       "choice_a":"VXLAN",
       "choice_b":"LISP",
       "choice_c":"SXP",
       "choice_d":"SGT",
       "choice_e":"802.1X",
       "correct_answer":"C",
       "explanation":"The Security Group Exchange protocol (SXP) sends mappings that tie source IP addresses to scalable group tags (SGTs). SXP uses Transmission Control Protocol (TCP) port 64999."
    },
    {
       "id":353,
       "topic_id":6,
       "practice_test_id":1,
       "domain":"Automation",
       "sub_domain":"Describe APIs for Cisco DNA Center and vManage",
       "question":"Which of the following HTTP response codes indicates successful authentication using a <code>GET</code> or <code>PUT</code> request?",
       "choice_a":200,
       "choice_b":201,
       "choice_c":204,
       "choice_d":401,
       "choice_e":500,
       "correct_answer":"A",
       "explanation":"When authenticating using a <code>GET</code> or <code>PUT</code> request, you should get a 200 response code if authentication succeeds."
    },
    {
       "id":354,
       "topic_id":6,
       "practice_test_id":2,
       "domain":"Automation",
       "sub_domain":"Interpret basic Python components and scripts",
       "question":"Which Python function would you use to authenticate to the Cisco DNA Center API?",
       "choice_a":"<code>requests.put()</code>",
       "choice_b":"<code>requests.post()</code>",
       "choice_c":"<code>requests.get()</code>",
       "choice_d":"<code>requests.patch()</code>",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"The <code>requests.put()</code> function is used to send your credentials to the API to obtain a token."
    },
    {
       "id":355,
       "topic_id":6,
       "practice_test_id":"",
       "domain":"Automation",
       "sub_domain":"Construct valid JSON encoded file",
       "question":"Which of the following is true of JSON?",
       "choice_a":"It uses curly braces to denote an object.",
       "choice_b":"It uses colons to denote an object.",
       "choice_c":"It uses curly braces to denote a key-value pair.",
       "choice_d":"It doesn't use commas.",
       "choice_e":"",
       "correct_answer":"A",
       "explanation":"JSON uses curly braces to denote an object. To separate key-value pairs, it uses a comma. Key names and values are separated by a colon."
    },
    {
       "id":356,
       "topic_id":6,
       "practice_test_id":"",
       "domain":"Automation",
       "sub_domain":"Describe the high-level principles and benefits of a data modeling language, such as YANG",
       "question":"What are the differences between YANG and XML? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> YANG is used for carrying configuration data.</li><li> YANG uses tags.</li><li> XML is used for carrying configuration data.</li><li> YANG is used for modeling configuration parameters.</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, C",
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"NETCONF uses XML for carrying configuration data. YANG is a data modeling language that represents the structure and constraints of configuration data."
    },
    {
       "id":357,
       "topic_id":6,
       "practice_test_id":2,
       "domain":"Automation",
       "sub_domain":"Describe APIs for Cisco DNA Center and vManage",
       "question":"What HTTP response code indicates a successful request that will take some time to process?",
       "choice_a":200,
       "choice_b":201,
       "choice_c":202,
       "choice_d":204,
       "choice_e":"",
       "correct_answer":"C",
       "explanation":"202 indicates the request has been accepted but will take time to process."
    },
    {
       "id":358,
       "topic_id":6,
       "practice_test_id":4,
       "domain":"Automation",
       "sub_domain":"Interpret REST API response codes and results in payload using Cisco DNA Center and RESTCONF",
       "question":"Which of the following HTTP response codes probably indicates that you mistyped a URL? <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>204</li><li>401</li><li>403</li><li>404</li><li>500</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "choice_e":"D, E",
       "correct_answer":"C",
       "explanation":"403 Forbidden could indicate that you called an API you're not authorized to access, perhaps by mistyping the URL. 404 Not found means the URL isn't valid."
    },
    {
       "id":359,
       "topic_id":6,
       "practice_test_id":5,
       "domain":"Automation",
       "sub_domain":"Construct EEM applet to automate configuration, troubleshooting, or data collection",
       "question":"What's true of the following EEM applet? <br> <code>event manager applet showrib</code> <br> <code>event none</code> <br> <code>action 1.0 cli command \u0022enable\u0022</code> <br> <code>action 20 cli command \u0022show ip route\u0022</code>",
       "choice_a":"It will write the output to the syslog.",
       "choice_b":"It can only be executed manually.",
       "choice_c":"It will display the IP routing table in the terminal console.",
       "choice_d":"It won't run.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The applet doesn't specify a triggering event, so it can only be run manually. The script won't display any output or write data to the syslog simply because there's no action to instruct it to do so."
    },
    {
       "id":360,
       "topic_id":6,
       "practice_test_id":2,
       "domain":"Automation",
       "sub_domain":"Compare agent vs. agentless orchestration tools, such as Chef, Puppet, Ansible, and SaltStack",
       "question":"The following code is an example of what language? <br> <code>---</code> <br> <code>- hosts: switches</code> <br> <code>roles: </code> <br> <code>- ospf</code>",
       "choice_a":"Python",
       "choice_b":"YAML",
       "choice_c":"Ruby",
       "choice_d":"YANG",
       "choice_e":"XML",
       "correct_answer":"B",
       "explanation":"The code is an example of YAML. One clue is the use of three dashes (<code>---</code>) on the first line."
    },
    {
       "id":361,
       "topic_id":6,
       "practice_test_id":3,
       "domain":"Automation",
       "sub_domain":"Interpret REST API response codes and results in payload using Cisco DNA Center and RESTCONF",
       "question":"Which of the following is required to use a RESTFUL API?",
       "choice_a":"Python",
       "choice_b":"Postman",
       "choice_c":"HTTP",
       "choice_d":"Ruby",
       "choice_e":"JSON",
       "correct_answer":"C",
       "explanation":"A RESTFUL application programming interface (API) uses HTTP actions."
    },
    {
       "id":362,
       "topic_id":6,
       "practice_test_id":3,
       "domain":"Automation",
       "sub_domain":"Describe the high-level principles and benefits of a data modeling language, such as YANG",
       "question":"YANG was designed for use with which of the following?",
       "choice_a":"RESTCONF",
       "choice_b":"NETCONF",
       "choice_c":"vManage REST API",
       "choice_d":"Cisco DNA Center Intent API",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"YANG (Yet Another Next Generation) is a structured data modeling language designed specifically for NETCONF. Essentially, YANG models set the rules for what constitute valid configuration parameters."
    },
    {
       "id":363,
       "topic_id":6,
       "practice_test_id":3,
       "domain":"Automation",
       "sub_domain":"Construct EEM applet to automate configuration, troubleshooting, or data collection",
       "question":"Consider the following commands to create an EEM applet: <br> <code>event manager applet WatchGig0/0</code> <br> <code>event syslog pattern \u0022Line protocol on Interface GigabitEthernet0/0, changed state to down\u0022 period 1</code><br> <code>action 1.0 cli command \u0022enable\u0022</code> <br> <code>action 1.1 cli command \u0022configure terminal\u0022</code> <br> <code>action 2.0 cli command \u0022interface gi0/0\u0022</code> <br> <code>action 3.0 cli command \u0022shut\u0022</code> <br> <code>action 2.5 cli command \u0022no shut\u0022</code> <br> What will be the end result when the line protocol on <code>GigabitEthernet0/0</code> goes down?",
       "choice_a":"<code>GgigabitEthernet0/0</code> will be up.",
       "choice_b":"<code>GigabitEthernet0/0</code> will be administratively shut down.",
       "choice_c":"The applet won't run due to insufficient permissions.",
       "choice_d":"The applet won't run because the event trigger is misconfigured.",
       "choice_e":"",
       "correct_answer":"B",
       "explanation":"The order of actions places the <code>shut</code> command after the <code>no shut</code> command, causing the interface to be administratively shut down."
    }
  ]